window.slate = window.slate || {};
window.theme = window.theme || {};
window.woolman = window.woolman || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  getCartToken: function() {
    return slate.cart.cookiesEnabled() ? slate.cookie.getCookie('cart') : '';
  },

  getCartTokenUrlParam: function() {
    const urlParams = new URLSearchParams(window.location.search),
          cartToken = (urlParams.has('cart_token')) ? urlParams.get('cart_token') : '';
    return cartToken;
  },

  isEmptyCart: function() {
    if (document.body.classList.contains('template-cart')) {
      return document.querySelector('.cart-table') === null;
    }
    const miniCart = document.querySelector('.off-canvas-cart'),
          cartEmpty = miniCart.querySelector('.cart-empty');
    return cartEmpty !== null;
  },

  removeCartTokenParamAndRefreshPage: function() {
    const cartTokenParam = slate.cart.getCartTokenUrlParam();
    if (cartTokenParam) {
      setTimeout(() => {
        const url = new URL(window.location.href);
        url.searchParams.delete('cart_token');
        // update the URL in the address bar without reloading
        window.history.pushState({}, '', url);
        // reload the page
        window.location.reload();
      }, 1500);
    }
  },

  hideCartLoader: function() {
    const loader = document.getElementById('cartLoader'),
          cartWrapper = document.getElementById('cartWrapper');
    if (!loader || !cartWrapper) {
      return;
    }
    if (!loader.classList.contains('hide')) {
      loader.classList.add('hide');
    }
    if (cartWrapper.classList.contains('hide')) {
      cartWrapper.classList.remove('hide');
    }
  }
};

/**
 * Cookies
 * ------------------------------------------------------------------------------
 * Useful functions for working with cookies.
 *
 * @namespace cookie
 */

slate.cookie = {
  getCookie: function(cname) {
    let name = cname + '=',
        splitCookies = document.cookie.split(';');
      for (let i = 0; i < splitCookies.length; i++) {
        let c = splitCookies[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
    return '';
  },

  /**
   * Example use cases:
   *
   * 1. set cookie max-age to 1 hour:
   * slate.cookie.setCookie('user', 'John', {secure: true, 'max-age': 3600});
   *
   * 2. set cookie to expire in 2 weeks:
   * slate.cookie.setCookie('user', 'John Doe', {
   *  secure: true,
   *  expires: new Date(Date.now() + 12096e5)
   * });
   */
  setCookie: function(name, value, attributes = {}) {
    attributes = {
      path: '/',
      // add other defaults here if necessary
      ...attributes
    };

    if (attributes.expires instanceof Date) {
      attributes.expires = attributes.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let attributeKey in attributes) {
      updatedCookie += '; ' + attributeKey;
      let attributeValue = attributes[attributeKey];
      if (attributeValue !== true) {
        updatedCookie += '=' + attributeValue;
      }
    }

    document.cookie = updatedCookie;
  },

  deleteCookie: function (name) {
    slate.cookie.setCookie(name, '', {
      'max-age': -1
    })
  }
};
  
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Theme Helpers
 * ------------------------------------------------------------------------------
 * Collection of utility methods for the theme.
 *
 * @namespace helpers
 */
theme.helpers = {
  sendAtpApiRequest: function (endPoint, requestData, callback) {
    const atpDomain = document.getElementById('atpDomain');
    if (!atpDomain || !atpDomain.value) {
      console.error('ATP domain not found');
      return;
    }
    const apiUrl = atpDomain.value + endPoint;
    let request = new XMLHttpRequest();
    request.open('POST', apiUrl);
    request.onload = function() {
      let res = JSON.parse(this.response);
      callback(this.status, res);
    };
    request.onerror = function() {
      console.log('request error');
    };
    request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    request.send(JSON.stringify({data: requestData}));
  },

  sendB2BApiRequest: function (endPoint, payload, callback) {
    const b2bAppDomain = document.getElementById('b2bAppDomain');
    if (!b2bAppDomain || !b2bAppDomain.value) {
      console.error('B2B app domain not found');
      return;
    }
    const apiUrl = b2bAppDomain.value + endPoint;
    let request = new XMLHttpRequest();
    request.open('POST', apiUrl);
    request.onload = function() {
      let res = JSON.parse(this.response);
      callback(this.status, res);
    };
    request.onerror = function() {
      console.log('request error');
    };
    request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    request.send(JSON.stringify(payload));
  },

  // For removing highlighted missing input data on form re-submission
  removeInvalidInputClasses: function () {
    let invalid_input = document.getElementsByClassName('is-invalid-input');
    while (invalid_input[0]) {
        invalid_input[0].classList.remove('is-invalid-input');
    }
  },

  displayLoader: function (selectors) {
    document.querySelector(selectors.submit_text).classList.add('is-hidden');
    document.querySelector(selectors.loader).classList.remove('is-hidden');
  },

  hideLoader: function (selectors) {
    document.querySelector(selectors.loader).classList.add('is-hidden');
    document.querySelector(selectors.submit_text).classList.remove('is-hidden');
  },

  // For removing error messages from screen
  removeErrorMessages: function () {
    document.querySelectorAll('.form-errors').forEach(el => el.classList.add('hidden'));
  },

  convertPhoneNumber: function(phoneNumber, countryCode) {
    if (!phoneNumber) {
      return null;
    }
    let phone = phoneNumber.trim().replace(/\s+/g, '').replace(/-/g, ''),
        code = '+' + countryCode;
    if (phone.substring(0, code.length) !== code) {
      if (phone.indexOf('+') !== -1) {
        return null;
      } else if (phone.charAt(0) === '0') {
        phone = code + phone.substring(1);
      } else {
        phone = code + phone;
      }
    }
    return phone;
  },

  /**
   * Returns an object representing a product with limited cart quantity.
   */
  getCartLimitedProductBySku: function(sku) {
    let product = null;
    const cartProductLimits = document.getElementById('cartProductLimits');
    if (!cartProductLimits) {
      return product;
    }
    const productLimit = cartProductLimits.querySelector(`[data-sku="${sku}"]`);
    if (productLimit) {
      const description = productLimit.getAttribute('data-description');
      const quantity = parseInt(productLimit.value);
      if (description && !isNaN(quantity)) {
        product = {sku: sku, description: description, quantity: quantity};
      }
    }
    return product;
  }
};
  
/**
 * Helper function for redirecting customer to ReCharge Checkout
 */
theme.gotoReChargeCheckout = (function() {

  function gotoReChargeCheckout(properties, alpoCustomerToken, discountCode) {

    var options = {
      permanent_domain: $('#shopify-options').data('permanent-domain'),
      checkout_domain: $('#shopify-options').data('checkout-domain')
    };
  
    var $asEmailPopupCampaignCodeInput = $('.as-email-popup--campaign-code #as-plus-campaign-code');

    /*
    |	Subscription Cart Footer fork
    |	http://rechargepayments.com: v3.0
    |	Updated: 2019/04/29
    */
      
    function get_cart_token() {
      // Build the cart_token param for the URL generator
      try {
        return ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2]];
      } catch(e) {
        return [];
      }
    }

    function get_ga_linker() {
      // Build the ga_linker param for the URL generator
      try {
        return [ga.getAll()[0].get('linkerParam')];
      } catch (e) {
        return [];
      }
    }

    function get_alpo_customer_token() {
      if (!alpoCustomerToken) {
        return [];
      }
      return ['alpo_customer_token=' + alpoCustomerToken];
    }

    function get_cookie(cname) {
      let name = cname + "=",
          splitCookies = document.cookie.split(';');
      for (let i = 0; i < splitCookies.length; i++) {
        let c = splitCookies[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    //Get cookie consent set by cookieinformation (https://cookieinformation.com/)
    function get_customer_cookie_information_consent() {
      let cookieInformationConsentCookies = get_cookie('CookieInformationConsent');
      if (!cookieInformationConsentCookies) {
        return [];
      }
      cookieInformationConsentCookies = JSON.parse(decodeURIComponent(cookieInformationConsentCookies));
      if (!cookieInformationConsentCookies.consents_approved) {
        return [];
      }
      let customerCookieInformationConsent = '',
          consentsApproved = cookieInformationConsentCookies.consents_approved;
      for (let i = 0; i < consentsApproved.length; i++) {
        customerCookieInformationConsent = customerCookieInformationConsent.concat(consentsApproved[i]+'=true&');			
      }
      if (customerCookieInformationConsent.charAt(customerCookieInformationConsent.length - 1) == "&"){
        customerCookieInformationConsent = customerCookieInformationConsent.slice(0, -1);
      }
      if (!customerCookieInformationConsent) {
        return [];
      }
      return [customerCookieInformationConsent];
    }

    function get_discount_code() {
      if (!discountCode) {
        return [];
      }
      return ['discount=' + discountCode];
    }

    function buildCheckoutUrl(options) {
      // Build the Checkout URL
      var checkout_url = 'https://' + options.checkout_domain + '/r/checkout?',
        url_params = [
          'myshopify_domain=' + options.permanent_domain
        ];

      url_params = url_params
        .concat(get_cart_token())
        .concat(get_ga_linker())      
        .concat(get_customer_cookie_information_consent())
        .concat(get_discount_code())
        .concat(get_alpo_customer_token());

      return checkout_url + url_params.join('&')
    }
    
    //GMT datalayer event
    function addToDataLayerAndRedirect() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'plus registration email validation completed',
        'campaignCode': $asEmailPopupCampaignCodeInput[0].value,
        'eventCallback' : function() {
          setTimeout(function(){ window.location = buildCheckoutUrl(options); }, 500);
        }
      });
    }

    /* AJAX add to cart */
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
    }).always(function(){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: properties,
        dataType: 'json',
        success: function(response) {
          if ($asEmailPopupCampaignCodeInput.length > 0) {
            addToDataLayerAndRedirect();
          } else {
            window.location = buildCheckoutUrl(options);
          }
        }, error: function(response) {
          console.dir(response);
          if ( response.responseJSON ) {
            var $alert = $('[data-audioservice-error-popup]');
            $alert.find('h2').text( response.responseJSON.message );
            $alert.find('p').text( response.responseJSON.description );
            $alert.foundation('open');
          }
        }
      });
    });
  }

	return gotoReChargeCheckout;
})();
theme.Slideshow = (function() {
	function Slideshow(container) {
		let accessibilitySlideLeft = document.querySelector("#accessibilityStrings").getAttribute("data-slide-left");
		let accessibilitySlideRight = document.querySelector("#accessibilityStrings").getAttribute("data-slide-right");

		let containerslidesToShow = 3;
		let containerslidesToShowMedium = 3;
		let containerslidesToShowSmall = 1;
		let containerslidesToScroll = 1;
		if(document.querySelector(container).getAttribute("data-slidesToShow")){
			containerslidesToShow = parseInt(document.querySelector(container).getAttribute("data-slidesToShow"));
		}
		if(document.querySelector(container).getAttribute("data-slidesToShowMedium")){
			containerslidesToShowMedium = parseInt(document.querySelector(container).getAttribute("data-slidesToShowMedium"));
		}
		if(document.querySelector(container).getAttribute("data-slidesToShowSmall")){
			containerslidesToShowSmall = parseInt(document.querySelector(container).getAttribute("data-slidesToShowSmall"));
		}
		if(document.querySelector(container).getAttribute("data-slidesToScroll")){
			containerslidesToScroll = parseInt(document.querySelector(container).getAttribute("data-slidesToScroll"));
		}

		$(container).slick({
			arrows: true,
			slidesToShow: containerslidesToShow,
			slidesToScroll: containerslidesToScroll,
			dots: true,
			adaptiveHeight: true,
			lazyLoad: 'progressive',
			prevArrow: '<button aria-label="' + accessibilitySlideLeft + '" type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="444" d="M3.45 10c0-.2.1-.3.21-.5L13.19.2a.82.82 0 0 1 .52-.2c.2 0 .3.1.51.2l1 1a.72.72 0 0 1 .21.5c0 .2-.21.3-.31.4L7.14 10l8.1 7.86a.72.72 0 0 1 .21.5c0 .2-.1.3-.21.5l-1 1a.79.79 0 0 1-.51.2c-.21 0-.31-.1-.52-.2L3.66 10.55A.82.82 0 0 1 3.45 10Z"/></svg></button>',
  			nextArrow: '<button aria-label="' + accessibilitySlideRight + '" type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 10.5 6.36 19.8a.82.82 0 0 1-.52.2c-.2 0-.3-.1-.51-.2l-1-1a.72.72 0 0 1-.21-.5c0-.2.1-.3.21-.5l8.1-7.9-8-7.8a.78.78 0 0 1-.21-.4 1.78 1.78 0 0 1 .21-.5l1-1A.82.82 0 0 1 5.84 0a.82.82 0 0 1 .52.2l9.53 9.3a.72.72 0 0 1 .21.5A.54.54 0 0 1 15.89 10.5Z"/></svg></button>',
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: containerslidesToShowSmall,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 1024,
					settings: {
					  slidesToShow: containerslidesToShowMedium,
					  slidesToScroll: containerslidesToScroll					  
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: containerslidesToShow,
						slidesToScroll: containerslidesToScroll					
					}
				}				
			]
		});
	}
	return Slideshow;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productLoyaltyPrice: '[data-loyalty-price]',
    loyaltyPriceInput: '[data-loyalty-price-input]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    storeAvailabilityTrigger: '[data-store-availability-trigger]',
    storeAvailabilityLists: '.store-availability-list',
    skAvailabilityMsgs: '[data-availability-for]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this, this.productSingleObject.tags));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // Store availability
    var $storeCheckTrigger = $(selectors.storeAvailabilityTrigger, this.$container),
        $availabilityLists = $(selectors.storeAvailabilityLists, this.$container);
    
    $storeCheckTrigger.on('click', function() {
      var $theProduct = $(this).closest('[data-the-product]'),
          storeAvailability = $theProduct.data('store-availability'),
          isbn_number = $theProduct.data('current-variant-sku');

      if (storeAvailability === 'unknown') {
        $theProduct.data('store-availability', 'requested')
        woolman.storeAvailabilityAjax(isbn_number, $availabilityLists);
      } else {
        console.log('No refetch');
      }
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(productTags, evt) {
      var variant = evt.variant;
      var skAvailability = document.querySelector('.add-to-cart').dataset.skAvailability;

      if (skAvailability == 'sk200') {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.availabilitySoldOut);
        return;
      }

      if (productTags.length > 0) {
        if (productTags.toString().toLowerCase().search('not buyable') !== -1) {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
          return;
        }
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $productLoyaltyPrice = $(selectors.productLoyaltyPrice, this.$container);
      var $loyaltyPriceInput = $(selectors.loyaltyPriceInput, this.$container);

      var variantPrices = JSON.parse($('[data-product-loyalty-price-json]').html());
      var loyaltyPrice = slate.Currency.formatMoney(variantPrices[evt.variant.id], theme.moneyFormat);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        slate.Currency.formatMoney(variantPrices[evt.variant.id], theme.moneyFormat)

      $productLoyaltyPrice.html(loyaltyPrice);
      $loyaltyPriceInput.val(slate.Currency.formatMoney(variantPrices[evt.variant.id], '{{ amount }}'));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
	function SlideshowSection(container) {
		var $container = this.container = $(container);
		var sectionId = $container.attr('data-section-id');
		var slideshow = this.slideshow = '#slideshow-' + sectionId;

		theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
	}

	return SlideshowSection;
})();


// FOR THEME EDITOR
theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
	onUnload: function() {
		delete theme.slideshows[this.slideshow];
	},

	onBlockSelect: function(evt) {
		var $slideshow = $(this.slideshow);

		// Ignore cloned slides
		var $slide = $('.slide-' + evt.detail.blockId + ':not(.slick-cloned');
		var slideIndex = $slide.data('slick-index');

		// Go to selected slide
		$slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
	},

	onBlockDeselect: function() {
		// Resume autoplay
		$(this.slideshow).slick('slickPlay');
	}
});

/**
 * @file scrollable-image-blocks.js
 * @description Handles the visibility of scroll buttons for horizontally scrollable image block sections.
 *              Ensures that scroll buttons are shown when content is scrollable and hidden otherwise.
 *              Also re-initializes when new sections are dynamically added (e.g., via Shopify theme editor).
 */

(function () {
  "use strict";

  function initScrollableImageBlocks() {
    const sections = document.querySelectorAll(".scroll-blocks-section");

    sections.forEach((section) => {
      const wrapper = section.querySelector(".scroll-blocks-wrapper");
      const updateScrollButtonLeft = section.querySelector(".scroll-btn.left");
      const updateScrollButtonRight =
        section.querySelector(".scroll-btn.right");
      let screenWidth = window.innerWidth;

      // Handle scroll button visibility. Show buttons if the content is scrollable, regardless of screen size.
      if (wrapper && updateScrollButtonLeft && updateScrollButtonRight) {
        function updateButtonVisibility() {
          const canScroll = wrapper.scrollWidth > wrapper.clientWidth;

          if (!canScroll) {
            updateScrollButtonLeft.classList.add("hide");
            updateScrollButtonLeft.setAttribute("disabled", "true");
            updateScrollButtonRight.classList.add("hide");
            updateScrollButtonRight.setAttribute("disabled", "true");
            return;
          }

          if (wrapper.scrollLeft === 0) {
            updateScrollButtonLeft.classList.add("hide");
            updateScrollButtonLeft.setAttribute("disabled", "true");
            updateScrollButtonRight.classList.remove("hide");
            updateScrollButtonRight.removeAttribute("disabled");
          } else if (
            wrapper.scrollLeft + wrapper.clientWidth >=
            wrapper.scrollWidth - 1
          ) {
            updateScrollButtonLeft.classList.remove("hide");
            updateScrollButtonLeft.removeAttribute("disabled");
            updateScrollButtonRight.classList.add("hide");
            updateScrollButtonRight.setAttribute("disabled", "true");
          } else {
            updateScrollButtonLeft.classList.remove("hide");
            updateScrollButtonLeft.removeAttribute("disabled");
            updateScrollButtonRight.classList.remove("hide");
            updateScrollButtonRight.removeAttribute("disabled");
          }
        }

        updateButtonVisibility();
        wrapper.addEventListener("scroll", updateButtonVisibility);
        window.addEventListener("resize", () => {
          screenWidth = window.innerWidth;
          updateButtonVisibility();
        });

        updateScrollButtonLeft.addEventListener("click", () => {
          const newScrollLeft = Math.max(
            0,
            wrapper.scrollLeft - wrapper.clientWidth
          );
          wrapper.scrollTo({
            left: newScrollLeft,
            behavior: "smooth",
          });
        });

        updateScrollButtonRight.addEventListener("click", () => {
          wrapper.scrollBy({
            left: wrapper.clientWidth,
            behavior: "smooth",
          });
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollableImageBlocks);
  } else {
    initScrollableImageBlocks();
  }

  // Re-initialize when new sections are added (for theme editor)
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.classList.contains("scroll-blocks-section")) {
      initScrollableImageBlocks();
    }
  });
})();

//-----------------------------------------------------------//
// CACHED SELECTORS
woolman.cacheSelectors = function() {
  woolman.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Nav
    $header                 : $('[data-header]'),
    $navButton              : $('[data-nav-button]'),
    $navigation             : $('[data-navigation]'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('[data-product-featured-image]'),
    $productThumbs           : $('[data-product-single-thumbnail]'),
    
    // Scroll To
    $scrollToButtons         : $('[data-scroll-to]'),
  };
};


//-----------------------------------------------------------//
// PRODUCT PAGE IMAGES
woolman.productImageSwitch = function() {
  if (woolman.cache.$productThumbs.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    woolman.cache.$productThumbs.on('click', function(evt) {
      woolman.cache.$productThumbs.removeClass('active');
      $(this).addClass('active');
      evt.preventDefault();
      var newImage = $(this).attr('href');
      woolman.switchImage(newImage, null, woolman.cache.$productImage);
    });
  }
};

woolman.storeAvailabilityAjax = function(isbn, $storeLists) {
  if (isbn === "") {
    console.log('No ISBN');
    return;
  };

  var params = {
    dataType: "json",
    // url can be edited on theme settings.store_saldo_api_url
    url: document.body.querySelector('#store-availability').dataset.url.trim() + isbn,
    success: function(availJson) {
      var availArray = availJson.Availability.Stock[0].Location,
          availArrayLength = availArray.length;          
      for (var i = 0; i < availArrayLength; i++) {
        var quantity = availArray[i].availability,
            location = availArray[i].location.trim().toUpperCase();
        if (quantity > 2) {
          
          if ( quantity >= 3 && quantity <= 6) {
            quantity = "3-6";
          } else if ( quantity >= 6 && quantity <= 10) {
            quantity = "6-10";
          } else if ( quantity >= 10 ) {
            quantity = "Yli 10";
          }
          
          $storeLists.find('[data-store-id="' + location + '"] .quantity').addClass('good-stock').text(quantity);
          $storeLists.find('[data-store-id="' + location + '"]').parent('li').removeClass('no-stock');
        } else if (quantity > 0) {
          quantity = "1-2";
          $storeLists.find('[data-store-id="' + location + '"] .quantity').addClass('few-left').text(quantity);
          $storeLists.find('[data-store-id="' + location + '"]').parent('li').removeClass('no-stock');
        } 
      }   

      //For checking if a parent element has a certain class
      function parentClassCheck(el, className) {
        while (el.parentElement) {
          el = el.parentElement;          
          if(el.classList.contains(className)) {            
            return true;                     
          }
        }
      }

      //For showing last on the list the stores where the product is not available.
      var l = 0;
      while (l < $storeLists.length ) {         
        var storeAvailabilityList = $storeLists[l].getElementsByTagName("li");
        var noStockStores = [];

        //There are 3 <ul> elements with class: "store-availability-list". Last one is on "click and colect" modal with class="cnc-stores" and does not display unavailable stores        
        if(parentClassCheck($storeLists[l], 'cnc-stores') == true){          
          l++;
          continue;
        }
       
        var j;
        for (j = 0 ; j < storeAvailabilityList.length; j++) {              
            if(storeAvailabilityList[j].classList.contains('no-stock')) {
              noStockStores.push(storeAvailabilityList[j]);                      
            }
          } 

        var k;
        for (k = 0 ; k < noStockStores.length; k++) {
          $storeLists[l].removeChild(noStockStores[k]); 
          $storeLists[l].append(noStockStores[k]);
        }
          
        l++;
      }

      $storeLists.removeClass('no-data');
    },error: function(XMLHttpRequest, textStatus) {
      console.log('Jotain män pieleeen:');
      console.log(textStatus);
      // Display error for IE users if there was an error.
      var ua = window.navigator.userAgent;
      var is_ie = /MSIE|Trident/.test(ua);
      if ( is_ie ) {
        $('#store-availability-alert').html('Käytät vanhentunutta selainta.<br><br>Ole hyvä ja <a href="https://browsehappy.com/" target="_blank">päivitä selaimesi</a> käyttökokemuksesi ja turvallisuutesi parantamiseksi.');
      } else {
        $('#store-availability-alert').html('Myymälätietojen haku epäonnistui.<br><br>Varmista, että käytät <a href="https://browsehappy.com/" target="_blank">selaimesi viimeisintä versiota.</a>');
      }
    }
  };
  $.ajax(params);
};

woolman.switchImage = function(src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};


//-----------------------------------------------------------//
// RESPONSIVE VIDEOS
woolman.responsiveVideos = function() {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="responsive-embed widescreen"></div>');
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

//-----------------------------------------------------------//
// ANIMATED SCROLL TO
woolman.scrollTo = function() {
  woolman.cache.$scrollToButtons.on('click', function(evt) {
    evt.preventDefault();
    var elementTo = '#' + $(this).data('scroll-to');
    var $targetElement = $(elementTo);

    if ($targetElement.length) {
      // Use custom offset if data-scroll-target-offset is present, otherwise default to 99
      var offset = $targetElement.data('scroll-target-offset') !== undefined
        ? parseInt($targetElement.data('scroll-target-offset'), 10)
        : 99;

      $('html, body').animate({
        scrollTop: ($targetElement.offset().top) - offset
      }, 600, function() {
        // Move keyboard focus to the target element after scrolling
        $targetElement.attr('tabindex', '-1').focus();

        // Remove tabindex after focus to maintain semantic structure
        $targetElement.on('blur', function() {
          $(this).removeAttr('tabindex');
        });
      });
    }
  });
};

//-----------------------------------------------------------//
// PRODUCT CARD
woolman.productCardSizes = function() {
  // Add gradient overlay to long card titles
  $('.product-title').each(function() {
    var height = $(this).height();
    if (height > 65) {
      $(this).addClass('gradient');
    }
  });

  // Match card image heights
  var maxHeight = 0;

  $('.card-image').each(function(){
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  // Let's not...
  // $('.card-image img').height(maxHeight);
};


//-----------------------------------------------------------//
// SORTING
woolman.collectionSort = function() {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('[data-sort-by] a')
    .on('click', function() {
      Shopify.queryParams.sort_by = jQuery(this).data('value');
      location.search = jQuery.param(Shopify.queryParams);
    }
  );
};


//-----------------------------------------------------------//
// HELPERS
woolman.jsonToStringHelper = function(customerJson) {
  var str = "";
  for (var key in customerJson) {
    if (str != "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(customerJson[key]);
  }

  return str;
};

// Mutation observer that watches for changes in the DOM and resolves when the specified selector is found.
woolman.waitForElm = function(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// IP location API
woolman.getIpLocation = function() {
  return new Promise(function(resolve, reject) {
    let XMLHttp = new XMLHttpRequest();
    XMLHttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        const ipwhois = JSON.parse(this.responseText);
        // Store the country code in session storage
        if (ipwhois.country_code) {
          sessionStorage.setItem('country_code', ipwhois.country_code);
        }
        resolve(ipwhois.country_code);
      }
    };
    XMLHttp.open('GET', 'https://ipwhois.pro?key=2PL5ikn37KeM88iJ', true);
    XMLHttp.send();
  });
};

woolman.promiseWithTimeout = function(promise, timeoutMs) {
  return new Promise((resolve, reject) => {
    // Set up a timeout that will reject the promise after a specified time
    const timeoutId = setTimeout(() => {
      reject(new Error('Request timed out'));
    }, timeoutMs);

    // Execute the original promise
    promise
      .then((result) => {
        clearTimeout(timeoutId);
        resolve(result);
      })
      .catch((error) => {
        clearTimeout(timeoutId);
        reject(error);
      });
  });
};

// Cart variables and init
var $cartButtonCount, $cart, $cartItemsContainer, $totalPrice, minForFreeShipping;

woolman.ajaxCartInit = function() {
  $cartButtonCount = $('[data-cart-count]'),
  $cart = $('[data-off-canvas-cart]'),
  $cartContent = $('[data-cart-content]'),
  $cartItemsContainer = $('#cartItems'),
  $totalPrice = $('#miniCartTotal');

  woolman.getAndBuildCart();
  woolman.cartItemQuantityClick();
};

woolman.cartItemQuantityClick = function() {
  $cart.on('click', '[data-update-quantity]', function() {

    var $clickedItem = $(this).closest('.quick-cart-item'),
        newCount = $clickedItem.data('item-count'),
        theVariantID = $clickedItem.data('product-id');

    if($(this).data('update-quantity') === 'increment') {
      newCount = newCount + 1;
    } else if ($(this).data('update-quantity') === 'decrement' ) {
      newCount = newCount - 1;
    };

    $('[data-update-quantity]').attr('disabled', 'disabled');
    $cart.addClass('loading');

    woolman.updateCartItem(theVariantID, newCount);
  });
};

woolman.getAndBuildCart = function() {
  $.getJSON('/cart.js', function (cart, textStatus) {
    woolman.buildCart(cart);
    woolman.giosgbasket(cart.items, cart.token);
  });
};

woolman.addToCart = function(form, skAvailability) {
  woolman.getProductCartData(form)
  .then((data) => {
    let items = [],
        limitedItems = [];
    items.push(data);
    if (document.getElementById('cartProductLimits')) {
      // there are cart limits defined in settings.cart_product_limits
      // check if there currently are items with cart limits
      for (let i = 0; i < Object.keys(items).length; i++) {
        const limitedItem = theme.helpers.getCartLimitedProductBySku(items[i].properties['_sku']);
        if (limitedItem) {
          limitedItems.push(limitedItem);
        }
      }
      if (limitedItems.length) {
        // there are items with limits, check if they are already in cart
        jQuery.getJSON("/cart.js", function (cart) {
          let cartLimitExceeded = false;
          for (let i = 0; i < cart.items.length; i++) {
            for (let z = 0; z < limitedItems.length; z++) {
              if (cart.items[i].sku == limitedItems[z].sku && cart.items[i].quantity >= limitedItems[z].quantity) {
                cartLimitExceeded = true;
                document.querySelector('#cartLimitInfoModal .reveal-inner p').innerHTML = limitedItems[z].description;
              }
            }
          }
          if (cartLimitExceeded) {
            // reveal modal with info about cart limits
            $('#cartLimitInfoModal').foundation('open');
            setTimeout(() => {
              $('#cartLimitInfoModal').foundation('close');
            }, 3000);
          } else {
            woolman.sendAjaxCartRequest(form, {items: items});
          }
        });
        return;
      }
    }

    let checkedBundleCheckboxes = null;
    if (document.getElementById('bundled-products') != undefined) {
      checkedBundleCheckboxes = document.querySelectorAll('.bundled_product_checkbox:checked');
    }

    if (checkedBundleCheckboxes && checkedBundleCheckboxes.length > 0) {
      // bundled products selected
      woolman.fetchBundledProductsData(checkedBundleCheckboxes)
      .then((bundledProducts) => {
        items = items.concat(bundledProducts);
        let productsWithLimits = false;
        for (let i = 0; i < Object.keys(items).length; i++) {
          if (items[i].properties._availability_code == "skheti") {
            productsWithLimits = true;
            break;
          }
        }
        if (productsWithLimits == true) {
          jQuery.getJSON("/cart.js", function (cart) {
            for (let k = 0; k < cart.items.length; k++) {
              for (let z = 0; z < Object.keys(items).length; z++) {
                if (items[z] == undefined) {
                  // already deleted from items
                  continue;
                } else if (items[z].properties._availability_code == "skheti" && items[z].id == cart.items[k].id) {
                  // already in cart, delete item
                  delete items[z];
                  $('#alreadyInCartModal').foundation('open');
                  setTimeout(() => {
                    $('#alreadyInCartModal').foundation('close');
                  }, 3000);
                  break;
                }
              }
            }
            //update key values to be consecutive:
            let newItems = {};
            for (let i = 0; i <= Object.keys(items).length; i++) {
              let oldKey = Object.keys(items)[i];
              delete Object.assign(newItems, items, {[i]: items[oldKey] })[oldKey];
            }

            // check ip location
            let countryCode = sessionStorage.getItem('country_code');
            if (countryCode) {
              if (countryCode == 'FI' || !countryCode) {
                woolman.sendAjaxCartRequest(form, {items: newItems});
              } else {
                // show info modal
                $('#ipLocationModal').foundation('open');
                setTimeout(() => {
                  $('#ipLocationModal').foundation('close');
                }, 3000);
              }
            } else {
              // get ip location from API
              woolman.promiseWithTimeout(woolman.getIpLocation(), 2000)
              .then(function(countryCode) {
                if (countryCode == 'FI' || !countryCode) {
                  woolman.sendAjaxCartRequest(form, {items: newItems});
                } else {
                  // show info modal
                  $('#ipLocationModal').foundation('open');
                  setTimeout(() => {
                    $('#ipLocationModal').foundation('close');
                  }, 3000);
                }
              })
              .catch(function(error) {
                console.error('Error:', error);
                woolman.sendAjaxCartRequest(form, {items: newItems});
              });
            }
          });
        } else {
          woolman.sendAjaxCartRequest(form, {items: items});
        }
      })
      .catch((error) => {
        console.log(error);
      });
    } else if (skAvailability == "skheti") {
      // check if product already in cart
      jQuery.getJSON("/cart.js", function (cart) {
        for (let i = 0; i < cart.items.length; i++) {
          for (let z = 0; z < Object.keys(items).length; z++) {
            if (items[z].id == cart.items[i].id) {
              // already in cart
              $('#alreadyInCartModal').foundation('open');
              setTimeout(() => {
                $('#alreadyInCartModal').foundation('close');
              }, 3000);
              delete items[z];
            }
          }
        }
        if (Object.keys(items).length > 0) {
          // check ip location
          let countryCode = sessionStorage.getItem('country_code');          
          if (countryCode) {
            if (countryCode == 'FI' || !countryCode) {
              woolman.sendAjaxCartRequest(form, {items: items});
            } else {
              $('#ipLocationModal').foundation('open');
              setTimeout(() => {
                $('#ipLocationModal').foundation('close');
              }, 3000);
            }
          } else {
            // get ip location from API
            woolman.promiseWithTimeout(woolman.getIpLocation(), 2000)
            .then(function(countryCode) {
              if (countryCode == 'FI' || !countryCode) {
                woolman.sendAjaxCartRequest(form, {items: items});
              } else {
                // show info modal
                $('#ipLocationModal').foundation('open');
                setTimeout(() => {
                  $('#ipLocationModal').foundation('close');
                }, 3000);
              }
            })
            .catch(function(error) {
              console.error('Error:', error);
              woolman.sendAjaxCartRequest(form, { items: items });
            });
          }
        }
      });
    } else {
      woolman.sendAjaxCartRequest(form, {items: items});
    }
  }).catch((error) => {
    console.log(error);
  });
};

woolman.sendAjaxCartRequest = function(form, postData) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: postData,
    dataType: 'json',
    beforeSend: function() {
      $(form).find('[type=submit]').attr('disabled', 'disabled').addClass('loading');
    },
    success: function(line_item) {
      //custobar add to cart function
      if (window.GlobalCustobarAddToCart && typeof window.GlobalCustobarAddToCart === 'function') {
        var skuArray = [];
        for (var i = 0; i < line_item.items.length; i++) {
          if (line_item.items[i].sku) {
            skuArray.push(line_item.items[i].sku);
          }
        }
        // Call the global function
        window.GlobalCustobarAddToCart(skuArray);
      }
      // Analytics event      
      const products = [];
      // Loop through the items object
      for (const key in line_item.items) {
        if (line_item.items.hasOwnProperty(key)) {
          const item = line_item.items[key];
          const id = item.id.toString(); // Convert the ID to a string for comparison with the page element ID

          // Check if an element with the ID exists on the page
          const element = document.getElementById(id);
          if (element) {
            // Check if the element has the class 'bundled_product_checkbox'
            const isBundledProduct = element.classList.contains('bundled_product_checkbox');

            // Create a new product object and add it to the products array
            const product = {
              name: isBundledProduct ? element.getAttribute("data-bundled-product-title") : element.getAttribute("data-gtm-title"),
              id: isBundledProduct ? element.getAttribute("data-bundled-product-sku") : element.getAttribute("data-gtm-sku"),
              price: isBundledProduct ? element.getAttribute("data-bundled-product-price") / 100 : element.getAttribute("data-gtm-price"),
              brand: isBundledProduct ? element.getAttribute("data-bundled-product-brand") : element.getAttribute("data-gtm-brand"),
              author: isBundledProduct ? element.getAttribute("data-bundled-product-author") : element.getAttribute("data-gtm-author"),
              category: isBundledProduct ? element.getAttribute("data-bundled-product-gtm-category") : element.getAttribute("data-gtm-category"),
              quantity: isBundledProduct ? element.getAttribute("data-bundled-product-quantity") : '1',
              categoryHierarchy: isBundledProduct ? element.getAttribute("data-bundled-product-category-hierarchy") : element.getAttribute("data-category-hierarchy"),
              url: isBundledProduct ? element.getAttribute("data-bundled-product-url") : element.getAttribute("data-url"),
              image: isBundledProduct ? element.getAttribute("data-bundled-product-image") : element.getAttribute("data-image"),
            };
            products.push(product);
          }
        }
      }
      // Subscribe to analytics event
      Shopify.analytics.publish('custom_add_to_cart',{
        event: 'Ecommerce add to cart',
        products: products
      });
     
      // Frosmo dataLayer
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: products.map(product => ({
              name: product.name,
              id: product.id,
              price: parseFloat(product.price),
              brand: product.brand,
              category: product.categoryHierarchy,
              url: window.location.origin + product.url,
              image: product.image.startsWith('https://') ? product.image : 'https:' + product.image,
            }))
          }
        }
      });

      $(form).find('.alertmsg').remove();
      woolman.getAndBuildCart();
      $('[data-off-canvas-cart]').foundation('open', 'addedToCart', form);
      // Show popup with info about gift card delivery
      $giftCardModal = $('#giftCardModal');
      if ($giftCardModal.length) {
        new Foundation.Reveal($giftCardModal);
        $giftCardModal.delay(500).fadeIn().foundation('open');
      }      
    },
    error: function(XMLHttpRequest, textStatus) {
      woolman.onError(XMLHttpRequest, textStatus, form);
    },
    complete: function(jqxhr, text) {
      $(form).find('[type=submit]').removeAttr('disabled').removeClass('loading');
      if (document.getElementById('bundled-products') != undefined) {
        //uncheck bundled products
        woolman.resetBundledProductCheckboxes();
      }
    }
  });
};

woolman.fetchBundledProductsData = function(checkboxEls) {
  return new Promise((resolve, reject) => {
    const promises = [];
    for (let i = 0; i < checkboxEls.length; i++) {
      promises.push(woolman.getBundledProductCartData(checkboxEls[i]));
    }
    Promise.all(promises).then((bundledProducts) => {
      // All requests succeeded
      resolve(bundledProducts);
    }).catch((e) => {
      // One or more requests failed
      reject(e);
    });
  });
};

woolman.getBundledProductCartData = function(bundledCheckboxEl) {
  return new Promise((resolve, reject) => {
    let productObj = {},
        props = {},
        handle = bundledCheckboxEl.dataset.bundledProductHandle;

    productObj.id = parseInt(bundledCheckboxEl.value);
    productObj.quantity = parseInt(bundledCheckboxEl.dataset.bundledProductQuantity);

    if (bundledCheckboxEl.dataset.bundledProductCompareAtPrice) {
      props['_compare_at_price'] = parseInt(bundledCheckboxEl.dataset.bundledProductCompareAtPrice);
    }
    if (bundledCheckboxEl.dataset.bundledProductLoyaltyPrice) {
      props['_loyalty_price'] = parseInt(bundledCheckboxEl.dataset.bundledProductLoyaltyPrice);
    }

    //data for analytics
    props['_item_bundled_with'] = bundledCheckboxEl.dataset.bundledMainProductSku;
    props['_gtm_category'] = bundledCheckboxEl.dataset.bundledProductGtmCategory;
    props['_frosmo_category'] = bundledCheckboxEl.dataset.bundledProductCategoryHierarchy;
    props['_dimension4'] = bundledCheckboxEl.dataset.bundledProductDimension4;

    woolman.getProductExtraData(handle, '?view=availability.json')
      .then((data) => {
        if (typeof data.availability_code !== 'undefined') {
          props['_availability_code'] = data.availability_code.toLowerCase();
        }
        if (typeof data.availability_text !== 'undefined') {
          props['_availability_text'] = data.availability_text;
        }
        if (typeof data.not_buyable !== 'undefined') {
          props['_not_buyable'] = (data.not_buyable === 'true') ? true : false;
        }
        if (typeof data.product_language !== 'undefined') {
          props['_product_language'] = data.product_language;
        }
        if (Object.keys(props).length > 0) {
          productObj['properties'] = props;
        }
        resolve(productObj);
      }).catch((error) => {
        reject(error);
      });
  });
};

woolman.resetBundledProductCheckboxes = function() {
  const bundleCheckboxes = document.getElementsByClassName('bundled_product_checkbox');
  for (i = 0; i < bundleCheckboxes.length; i++) {
    bundleCheckboxes[i].checked = false;
    bundleCheckboxes[i].dataset.bundledProductQuantity = 0;
    let countIndicator = bundleCheckboxes[i].closest('.individual-bundled-product').querySelector('.count-indicator');
    countIndicator.innerHTML = 0;
    countIndicator.style.display = 'none';
  }
  //bundle total price reset
  let bundlePriceDiv = document.getElementById('bundle-price');
  bundlePriceDiv.innerHTML = bundlePriceDiv.getAttribute('data-current-variant-price');
};

woolman.getProductCartData = function(form) {
  return new Promise((resolve, reject) => {
    let props = {},
    productObj = {quantity: 1},
    attributes = $(form).serializeArray();
    attributes.forEach((item) => {
      if (item.name.includes('properties[')) {
        props[item.name.replace('properties[','').slice(0,-1)] = item.value;
      } else {
        productObj[item.name] = item.value;
      }
    });

    if (props._handle && props._handle.length > 0) {
      woolman.getProductExtraData(props._handle, '?view=availability.json')
      .then((data) => {
        if (typeof data.availability_code !== 'undefined') {
          props['_availability_code'] = data.availability_code.toLowerCase();
        }
        if (typeof data.availability_text !== 'undefined') {
          props['_availability_text'] = data.availability_text;
        }
        if (typeof data.not_buyable !== 'undefined') {
          props['_not_buyable'] = (data.not_buyable === 'true') ? true : false;
        }
        if (typeof data.product_language !== 'undefined') {
          props['_product_language'] = data.product_language;
        }
        if (Object.keys(props).length > 0) {
          productObj['properties'] = props;
        }
        resolve(productObj);
      }).catch((error) => {
        reject(error);
      });
    } else {
      console.log('Could not fetch product availability data. Line item property not defined: handle');
      if (Object.keys(props).length > 0) {
        productObj['properties'] = props;
      }
      resolve(productObj);
    }
  });
};

woolman.deleteCartItem = function(item_id) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates[+' + item_id + ' +]=0',
    dataType: 'json',
    success: function(cart) {
      woolman.buildCart(cart);
      $cart.removeClass('loading');
      woolman.giosgbasket(cart.items, cart.token);
    }
  };

  $.ajax(params);
};

woolman.updateCartItem = function(item_id, item_count) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates[+' + item_id + ' +]=' + item_count,
    dataType: 'json',
    success: function(cart) {
      woolman.buildCart(cart);
      $('[data-update-quantity]').removeAttr('disabled');
      $cart.removeClass('loading');
      woolman.giosgbasket(cart.items, cart.token);
    },
    error: function(XMLHttpRequest) {      
      woolman.updateError(XMLHttpRequest, item_id);
      $('[data-update-quantity]').removeAttr('disabled');
      $cart.removeClass('loading');      
    }
  };

  $.ajax(params);
};

woolman.updateError = function(XMLHttpRequest, item_id) {
  var clickedItem = $('[data-product-id="' + item_id + '"]');
  var availabilityEl = clickedItem.find('.quick-cart-availability');
  availabilityEl.find('.alertmsg').remove();
  availabilityEl.append( '<p class="alertmsg text-muted">' + XMLHttpRequest.responseJSON.description + '</p>' );
  // remove after 5s
  setTimeout(function() {
    availabilityEl.find('.alertmsg').remove();
  }, 5000);
}

woolman.onError = function(XMLHttpRequest, textStatus, sourceForm) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    $(sourceForm).find('.alertmsg').remove();
    $(sourceForm).append( '<p class="alertmsg"><i class="fa fa-exclamation-triangle"></i>' + data.description + '</p>' );
  }
};

woolman.buildCart = function(cart) {
  // Show empty cart
  if (cart.item_count === 0) {
    $cartButtonCount.addClass('hide');
    $cartContent.html('<p class="cart-empty">' + $("#ajax-cart-template").data('empty-msg') + '</p>');    
    return;
  }
  $cartButtonCount.html(cart.item_count).removeClass('hide');
  // Handlebars.js cart layout

  var items = [],
      item = {},
      data = {},
      source = $("#ajax-cart-template").html(),
      template = Handlebars.compile(source),
      totalLoyaltyDiscounts = 0,
      plusItems = [],
      plusElement =  document.getElementById("plus_products_list");
      if (typeof(plusElement) != 'undefined' && plusElement != null) {
        var plusValues = plusElement.value;
        plusValues = plusValues.split(",");
        for (let i = 0; i < plusValues.length; i++) {
          plusItems.push(parseInt(plusValues[i]));
        }
      }
  // Add each item to our handlebars.js data
  $.each(cart.items, function(index, cartItem) {
    if (plusItems.length != 0) {
      // Check if variant_id is in the list of plus products
      // Remove item from cart if found from the list
      if ( plusItems.includes(cartItem.variant_id) !== false) {
        $cart.addClass('loading');
        woolman.deleteCartItem(cartItem.variant_id);
      }
    }

    var itemCompareAtPrice = 0,
        itemLoyaltyDiscount = 0,
        itemLoyaltyPrice = 0;

    if (cartItem.image != null){
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_120x120$1").replace('http:', '');
    } else {
      var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
    }

    if (cartItem.properties != null && cartItem.properties["_compare_at_price"]){
      itemCompareAtPrice = cartItem.properties["_compare_at_price"];
    }

    if (cartItem.properties != null && cartItem.properties["_loyalty_price"]){
      itemLoyaltyDiscount = cartItem.original_price - cartItem.properties["_loyalty_price"],
      itemLoyaltyPrice = cartItem.properties["_loyalty_price"];
    }

    if (itemLoyaltyDiscount !== 0) {
      totalLoyaltyDiscounts = totalLoyaltyDiscounts + (cartItem.quantity * itemLoyaltyDiscount);
    }

    let plusButtonClass = "";

    if (cartItem.properties != null &&
        cartItem.properties['_availability_code'] &&
        cartItem.properties['_availability_code'] == 'skheti') {
        plusButtonClass = 'disabled';
    } else if (cartItem.properties != null && cartItem.properties['_free_gift_product'] == 'true') {
      plusButtonClass = 'disabled';
    } else if (document.getElementById('cartProductLimits')) {
      const limitedProduct = theme.helpers.getCartLimitedProductBySku(cartItem.sku);
      if (limitedProduct && cartItem.quantity >= limitedProduct.quantity) {
        plusButtonClass = 'disabled';
      }
    }

    // Create item's data object and add to 'items' array
    item = {
      variantId: cartItem.variant_id,
      url: cartItem.url,
      imgSrc: prodImg,
      count: cartItem.quantity,
      productTitle: cartItem.product_title,
      variantTitle: cartItem.variant_title,
      productType: cartItem.product_type,
      price: slate.Currency.formatMoney((cartItem.quantity * cartItem.final_price), theme.moneyFormat),
      originalPrice: slate.Currency.formatMoney((cartItem.quantity * cartItem.original_price), theme.moneyFormat),
      hasCompareAtPrice: itemCompareAtPrice === 0 ? false : true,
      compareAtPrice: slate.Currency.formatMoney((cartItem.quantity * itemCompareAtPrice), theme.moneyFormat),
      hasAutomaticDiscount: cartItem.discounts.length > 0 && cartItem.final_price < cartItem.original_price ? true : false,
      hasLoyaltyPrice: itemLoyaltyDiscount === 0 ? false : true,
      loyaltyPrice: slate.Currency.formatMoney((cartItem.quantity * itemLoyaltyPrice), theme.moneyFormat),
      requiresShipping: cartItem.requires_shipping,
      plusButtonClass: plusButtonClass
    };
    items.push(item);
  });

  // To check if cart items qualify for free shipping and update shipping message
  var i;
  var productsWithShippingTotal = parseFloat(cart.total_price);
  var missingForFreeShipping = 0;
  var shippingToggleBellow = '';
  var shippingToggleAbove = '';
  minForFreeShipping = $("#ajax-cart-template").data('min-shipping');


  for (i = 0; i < items.length; i++) {
    if(items[i].requiresShipping != true){
      productsWithShippingTotal = Math.round(productsWithShippingTotal - (parseFloat(items[i].price.replace(',', '.'))*100));
    }
  }
  if(productsWithShippingTotal == 0){
    shippingToggleBellow = 'display: none !important';
    shippingToggleAbove = 'display: none !important';
  }else if(productsWithShippingTotal < minForFreeShipping){
    missingForFreeShipping = ((minForFreeShipping - productsWithShippingTotal)/100).toFixed(2).toString().replace(".", ",");
    shippingToggleBellow = '';
    shippingToggleAbove = 'display: none !important';
  }else{
    shippingToggleBellow = 'display: none !important';
    shippingToggleAbove = '';
  }

  // Gather all cart data and add to DOM
  data = {
    items: items,
    note: cart.note,
    hasCartLevelDiscount: cart.cart_level_discount_applications.length > 0 ? true : false,
    originalTotalPrice: slate.Currency.formatMoney(cart.original_total_price, theme.moneyFormat),
    totalPrice: slate.Currency.formatMoney(cart.total_price, theme.moneyFormat),
    hasLoyaltyDiscounts: totalLoyaltyDiscounts === 0 ? false : true,
    totalLoyaltyDiscounts: slate.Currency.formatMoney(totalLoyaltyDiscounts, theme.moneyFormat),
    shippingToggleBellow: shippingToggleBellow,
    shippingToggleAbove: shippingToggleAbove,
    missingForFreeShipping: missingForFreeShipping,
  }

  $cartContent.html(template(data));

  woolman.populateProductExtraData(cart.items);

  woolman.updateDeliveryEstimate(cart.items);

  $(document.body).trigger('ajaxCartLoaded');
  
  woolman.freeGiftProduct(data.items);

  woolman.checkDisabledButtons();

  woolman.digitalProductsB2b(cart.items); //Inform B2B customers that they cannot buy digital products
};

woolman.checkDisabledButtons = function () {
  //check if disabled buttons have the correct attribute
  let disabledButtons = document.querySelector('div#cartItems').getElementsByClassName("disabled");
  setTimeout(() => {
    for (let i = 0; i < disabledButtons.length; i++) {
      disabledButtons[i].setAttribute("disabled", "disabled");
    }
  }, 500);
};

woolman.getProductExtraData = function (handle, teamplateView) {
  return new Promise((resolve, reject) => {
    // Remove parameters from handle if present
    let handleWithoutParams = handle.split('?')[0];
    
    $.ajax({
      url: window.location.origin + '/products/' + handleWithoutParams + teamplateView,
      type: 'GET',
      success: function (data) {
        if (!data) {
          reject(new Error('Shopify availability template returned a malformed JSON response'));
        }

        let json = data.replace(/(\r\n|\n|\r)/gm, '').trim();

        if (json.charAt(0) !== '{') {
          reject(new Error('Shopify availability template returned a malformed JSON response'));
        }

        resolve(JSON.parse(json));
      },
      error: function (error) {
        reject(error);
      },
    })
  });
};

woolman.populateProductExtraData = function (items) {// Availability, language
  $.each(items, function(index, cartItem) {
    if (typeof cartItem.properties === 'object' && Object.keys(cartItem.properties).length > 0) {
      let props = cartItem.properties;
      let miniCartItem = $('#offCanvasCart').find('#cartItems .quick-cart-item[data-product-id="'+ cartItem.id +'"]');
      let not_buyable = (props._not_buyable === 'true') ? true : false;
      if (miniCartItem.length && props._availability_text && !not_buyable) {
        let availabilityEl = miniCartItem.find('.quick-cart-availability'),
            availabilityMessage = availabilityEl.find('.availability-message'),
            deliveryEstimateMessage = availabilityEl.find('.delivery-estimate-message');

        availabilityMessage.find('span').text(props._availability_text);
        let availabilityMessageTitle = $('#messages-title-data').attr("data-availability-message");
        deliveryEstimateMessage.find('.message-title').text(availabilityMessageTitle);
        deliveryEstimateMessage.find('.message-text').text(props._availability_text);
        availabilityEl.removeClass('hide');
      }
      if (miniCartItem.length && props._product_language) {
        let languageEl = miniCartItem.find('.productLanguage');
        languageEl.text(", " + props._product_language);
      }
    }
  });
};

woolman.updateDeliveryEstimate = function (items) {
  const shipTogetherEnabled = document.getElementById('shipTogetherEnabled').value === 'true';

  // Exit if ship together is not enabled
  if (!shipTogetherEnabled) {
    return;
  }

  // Get included codes from hidden input #shipTogetherSkCodes
  let shipTogetherSkCodes = [];
  const shipTogetherSkCodesInput = document.getElementById('shipTogetherSkCodes');
  if (shipTogetherSkCodesInput && shipTogetherSkCodesInput.value) {
    shipTogetherSkCodes = shipTogetherSkCodesInput.value
      .split(',')
      .map(code => code.trim().toLowerCase())
      .filter(Boolean);
  }

  if (!shipTogetherSkCodes.length) {
    return;
  }

  let showInfoMessage = false;
  const updateMessagesInput = document.getElementById('updateAvailabilityMessages');

  // Filter out items that do not have availability code or are not in shipTogetherSkCodes
  items = items.filter(item => {
    const code = item.properties?._availability_code;
    return item.properties && code && shipTogetherSkCodes.includes(code);
  });

  // Check if items is an array and has at least one item
  if (!items || items.length === 0) {
    return;
  }

  // Find the highest code (sk1, sk2, ...) only among codes in shipTogetherSkCodes
  let highestCode = null,
      highestCodeNum = -1,
      highestCodeText = '';

  items.forEach(item => {
    const code = item.properties._availability_code;
    const num = parseInt(code.replace('sk', ''), 10);
    if (num > highestCodeNum) {
      highestCodeNum = num;
      highestCode = code;
      highestCodeText = (item.properties?._availability_text || '').trim();
    }
  });

  const highestCodeUpdatedText = updateMessagesInput.getAttribute(`data-${highestCode}_update`) || highestCodeText;

  // Use an async IIFE to process items sequentially with await
  (async () => {
    for (const item of items) {
      const code = item.properties._availability_code.trim().toLowerCase();
      const updatedAvailabilityText = item.properties?._updated_availability_text;
      if (updatedAvailabilityText && code === highestCode) {
        // Remove _updated_availability_text from properties
        const { _updated_availability_text, ...cleanedProperties } = item.properties;
        await new Promise((resolve) => {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: item.key,
              properties: cleanedProperties
            },
            dataType: 'json',
            success: function(cart) {
              let deliveryEstimateMessage = $('[data-product-id="' + item.id + '"]').find('.delivery-estimate-message');
              deliveryEstimateMessage.find('.updated-message-text').text('');
              deliveryEstimateMessage.find('.message-text').css('text-decoration', '');
              setTimeout(resolve, 200); // allow some time for UI update
            },
            error: function(error) {
              console.error(`Failed to remove _updated_availability_text from item ${item.id}`, error);
              setTimeout(resolve, 200);
            }
          });
        });
      } else if (
        code !== highestCode &&
        updatedAvailabilityText !== highestCodeUpdatedText &&
        item.properties._availability_text !== highestCodeText
      ) {
        // Add _updated_availability_text property
        const updatedProperties = {
          ...item.properties,
          _updated_availability_text: highestCodeUpdatedText
        };
        await new Promise((resolve) => {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: item.key,
              properties: updatedProperties
            },
            dataType: 'json',
            success: function(cart) {
              let deliveryEstimateMessage = $('[data-product-id="' + item.id + '"]').find('.delivery-estimate-message');
              deliveryEstimateMessage.find('.message-text').css('text-decoration', 'line-through');
              deliveryEstimateMessage.find('.updated-message-text').text(highestCodeUpdatedText);
              showInfoMessage = true;
              setTimeout(resolve, 200);
            },
            error: function(error) {
              console.error(`Failed to update _updated_availability_text for item ${item.id}`, error);
              setTimeout(resolve, 200);
            }
          });
        });
      } else if (updatedAvailabilityText) {
        // Only show updates      
        let deliveryEstimateMessage = $('[data-product-id="' + item.id + '"]').find('.delivery-estimate-message');
        deliveryEstimateMessage.find('.message-text').css('text-decoration', 'line-through');
        deliveryEstimateMessage.find('.updated-message-text').text(updatedAvailabilityText);
        showInfoMessage = true;
        await new Promise((resolve) => setTimeout(resolve, 100)); // small delay for UI
      }
    }

    if (showInfoMessage) {
      document.getElementById('deliveryUpdateInfo').classList.remove('hide');
    } else {
      document.getElementById('deliveryUpdateInfo').classList.add('hide');
    }
  })();
}

// Free product gift
woolman.freeGiftProduct = function() {
  let freeGiftProductHandle = document.getElementById("freeGiftProductHandle");
  if ( !freeGiftProductHandle ) {
    // No gift product found
    return;
  }

  setTimeout(() => {
    woolman.getProductExtraData(freeGiftProductHandle.value, '?view=free-gift.json').then((data) => {
      let qualifyingProductInCart = data.qualifyingProductInCart;
      let qualifyingProductCount = data.qualifyingProductCount;
      let freeGiftProduct = data.freeGiftProduct;// variant id
      let freeGiftTargetCustomers = data.targetCustomers;
      let freeGiftLoyaltyCustomer = data.freeGiftLoyaltyCustomer;
      let freeGiftProductInCart = data.freeGiftProductInCart;
      let freeGiftProductCount = data.freeProductCount;
      let freeGiftProductMax = data.freeProductMax;
      let popUpShownCount = parseInt(sessionStorage.getItem("FreeGiftPopUp"), 10);

      function showFreeGiftPopUp(ShownCount) {
        if ( ShownCount === null || isNaN(ShownCount) === true ) {
          sessionStorage.setItem("FreeGiftPopUp", "1");
          $('#freeGiftModal').foundation('open');
        } else if ( ShownCount === 1 ) {
          sessionStorage.setItem("FreeGiftPopUp", "2");
          $('#freeGiftModal').foundation('open');
        } else if ( ShownCount >= 2 && ShownCount < 8 ) {
          sessionStorage.setItem("FreeGiftPopUp", parseInt(ShownCount, 10 ) + 1);
          setTimeout(() => {
            $('#freeGiftModal').foundation('open');
          }, ShownCount * 1500 );
        } else {
          // do nothing
        }
      }

      switch (freeGiftProductMax) {
        case 'single':
          if ( qualifyingProductInCart === true && freeGiftTargetCustomers === "all" && freeGiftProductInCart === false ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if ( qualifyingProductInCart === true && freeGiftTargetCustomers === "loyalty" && freeGiftLoyaltyCustomer === true && freeGiftProductInCart === false ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if (qualifyingProductInCart === true && freeGiftTargetCustomers === "loyalty" && freeGiftLoyaltyCustomer !== true && freeGiftProductInCart === false) {
            // todo: pop up with message that free gift for loyalty customers only
          } else if ( qualifyingProductInCart === false && freeGiftProductInCart === true ) {
            // remove free gift product from cart
            woolman.deleteCartItem(freeGiftProduct);
          } else if ( qualifyingProductInCart === true && freeGiftProductInCart === true ) {
            sessionStorage.removeItem("FreeGiftPopUp");
          } else {
            // no free gift product conditions met
          }          
          break;
        case 'one_per_item':
          if ( qualifyingProductCount >= 1 && freeGiftProductCount < qualifyingProductCount && freeGiftTargetCustomers === "all" ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if ( qualifyingProductCount >= 1 && freeGiftProductCount < qualifyingProductCount && freeGiftTargetCustomers === "loyalty" && freeGiftLoyaltyCustomer === true && freeGiftProductInCart === false ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if (qualifyingProductInCart === true && freeGiftTargetCustomers === "loyalty" && freeGiftLoyaltyCustomer !== true && freeGiftProductInCart === false) {
            // todo: pop up with message that free gift for loyalty customers only
          } else if ( qualifyingProductInCart === false && freeGiftProductInCart === true ) {
            // remove free gift product from cart
            woolman.deleteCartItem(freeGiftProduct);
          } else if ( qualifyingProductInCart === true && freeGiftProductInCart === true ) {
            sessionStorage.removeItem("FreeGiftPopUp");
          } else {
            // no free gift product conditions met
          }          
          break;
        case 'multiple':
          if ( qualifyingProductInCart === true && freeGiftTargetCustomers === "all" && freeGiftProductInCart === false ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if ( qualifyingProductInCart === true && freeGiftTargetCustomers === "loyalty" && freeGiftLoyaltyCustomer === true && freeGiftProductInCart === false ) {
            $('[data-off-canvas-cart]').foundation('close');
            showFreeGiftPopUp(popUpShownCount);
          } else if ( qualifyingProductInCart === true && freeGiftProductInCart === true ) {
            sessionStorage.removeItem("FreeGiftPopUp");
          }
      }

      if ( freeGiftProductCount > 1 && freeGiftProductMax == "single" ) {
        $.getJSON('/cart.js', function (cart) {
          for (let i = 0; i < freeGiftProductCount-1; i++) {
            if (cart.items[i].id == freeGiftProduct) {
              woolman.deleteCartItem(cart.items[i].key); // item key identifies the item in the cart
            }
          }
        });
      } else if ( freeGiftProductCount > 1 && freeGiftProductCount > qualifyingProductCount && freeGiftProductMax == "one_per_item" ) {
        $.getJSON('/cart.js', function (cart) {
          for (let i = 0; i <= qualifyingProductCount; i++) {
            if (cart.items[i].id == freeGiftProduct) {
              woolman.deleteCartItem(cart.items[i].key); // item key identifies the item in the cart
            }
          }
        });
      }

    }).catch((error) => {
      reject(error);
    });
    
  }, 1000);
};

// Check if customer is B2B and has digital products in cart
woolman.digitalProductsB2b = function(items) {
  if (!document.getElementById('customer_type') || document.getElementById('customer_type').value !== 'b2b_customer') {
    // Not a B2B customer
    return;
  }
  
  const hasSkheti = items.some(item => 
    item.properties && item.properties._availability_code && item.properties._availability_code.toUpperCase() === "SKHETI"
  );
  
  if (hasSkheti) {
    // Show modal only if not shown in the last 5 minutes
    const lastShown = sessionStorage.getItem('digitalProductsB2bModalLastShown');
    const now = Date.now();
    const noShowTime = 5 * 60 * 1000; // 5 minutes in milliseconds

    if (!lastShown || now - parseInt(lastShown, 10) > noShowTime) {
      setTimeout(function() {
        $('#digitalProductsB2bModal').foundation('open');
        sessionStorage.setItem('digitalProductsB2bModalLastShown', now.toString());
      }, 2000);
    }
  }
}

//giosg basket
woolman.giosgbasket = function(items, cartToken){
  let products = [];
  for (let i = 0; i < items.length; i++) {    
    let item = { 
      name: items[i].title,
      price: items[i].final_price / 100,
      quantity: items[i].quantity
    };
    products.push(item);
  }

  function updateGiosgBasket(products) {
    if(products.length <= 0 ) {
      _giosg(function() {
        giosg.api.visitor.setIdentifier(cartToken.split("?")[0]);
        giosg.api.shoppingCart.clearCart();
      })
    }else {
      _giosg(function() {
        giosg.api.visitor.setIdentifier(cartToken.split("?")[0]);
        giosg.api.shoppingCart.submit(products);
      })
    }
  }

  function setGiosgCheckInterval(callback, delay, iterations) {
    let i = 0;
    let intervalID = window.setInterval(function () {
      if (i >= iterations) {
        window.clearInterval(intervalID);
        return;
      }
      callback(intervalID);
      i++;
    }, delay);
  }
  
  if( typeof _giosg !== 'undefined' && typeof giosg !== 'undefined' ){ //giosg ready
    updateGiosgBasket(products);
  }else { //giosg not ready
    setGiosgCheckInterval(function (intervalID) {
      if( typeof _giosg !== 'undefined' && typeof giosg !== 'undefined' ){ //giosg ready
        updateGiosgBasket(products);
        window.clearInterval(intervalID);
      }
    }, 500, 3);
  }
}
/**
 * Customer Account Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Account
 * template.
 *
 * @namespace customerAccount
 */

Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
});

theme.customerAccount = (function() {
  let $myDetailsContainer = $('#myDetailsContainer'),
      $ajaxErrors = $('#ajaxErrors'),
      $loadingMessages = $('.loading-user'),
      $syncingMessage = $('#syncingMessage'),
      $syncFailedMessage = $('#syncFailedMessage');

  if (!$myDetailsContainer.length) {
    return;
  }

  let $marketingSettingsSubmit = $('#customer-marketing-settings-submit'),
      marketingPermissionInitialValues = {},
      marketingGroups = {
        suomalainenKirjakauppa: {
          email: 'Suomalainen_kirjakauppa',
          sms: 'suomalainen__kirjakauppa_sms',
          mail: 'suomalainen__kirjakauppa_mail'
        },
        // bookclub members cannot change their mail permission
        sskk: {
          email: 'SSKK',
          sms: 'suomalainen__sskk_sms'
        }
      },
      getRequestRetryAttempts = 0,
      ajaxMaxRetryAttempts = 3;

  // Format customer parameters
  let customer_id = $('#customerID').val(),
      email = $('#customerEmail').val(),
      external_id = $('#externalID').val(),
      shop_domain = $('#shopDomain').val(),
      timestamp = $('#timestamp').val(),
      hmac_digest = $('#hmac_digest').val(),
      atp_domain = $('#atpDomain').val();

  let customerParams = {
    "external_id": external_id,
    "customer_id": customer_id,
    "email": email,
    "shop": shop_domain,
    "timestamp": timestamp
  };
  let parsedCustomerParams = woolman.jsonToStringHelper(customerParams);
  
  getUserDetails = function() {
    const apiUrl = atp_domain + '/api/omasuomalainen/customers?' + parsedCustomerParams;
    $.ajax({
      type: "GET",
      contentType: 'application/json',
      headers: {
        "X-Authorization-Content-SHA256": hmac_digest
      },
      url: apiUrl,
      data: {},
      dataType: 'json',
      success: function(response_json) {
        buildMyDetails(response_json.customer); // CHANGE from customer array to single object
        $loadingMessages.hide();
        $ajaxErrors.hide();
        $syncingMessage.hide();
      },
      error: function(XMLHttpRequest, textStatus) {
        let errorMsg = '';

        if (XMLHttpRequest.status == 400) {
          // Invalid signature
          errorMsg = $ajaxErrors.data('error-400');
          console.log('Invalid signature');
        } else if (XMLHttpRequest.status == 403) {
          // Expired signature
          errorMsg = $ajaxErrors.data('error-403');
          $ajaxErrors.find('.button').removeClass('hide');
          console.log('Expired signature');
        } else if (XMLHttpRequest.status == 404) {
          // No custobar user
          $syncingMessage.removeClass('hide');
          $loadingMessages.hide();
          let tabID = $myDetailsContainer.closest('.accordion-content').attr('id'),
              theTab = $('#' + tabID);
          $('#accountAccordion').foundation('down', theTab);
          let redirNum = 8;
          let redirTimer = setInterval(function() {
            if (getRequestRetryAttempts > ajaxMaxRetryAttempts) {
              $loadingMessages.hide();
              $ajaxErrors.hide();
              $syncingMessage.hide();
              $syncFailedMessage.removeClass('hide');
              clearInterval(redirTimer);
            } else {
              --redirNum;
              if (redirNum <= 0) {
                clearInterval(redirTimer);
                getUserDetails();
                getRequestRetryAttempts++;
              }
            }
          }, 1000);
        } else {
          errorMsg = $ajaxErrors.data('error-common');
          console.log('Error: ' + XMLHttpRequest.status);
        }

        if (XMLHttpRequest.status != 404) {
          errorMsg = errorMsg + ' (virhekoodi: ' + XMLHttpRequest.status + ')';
        }

        $ajaxErrors.find('.message').text(errorMsg);
        $ajaxErrors.removeClass('hide');
        $loadingMessages.hide();
      }
    });
  };

  // Build my details block
  buildMyDetails = function(userData) {
    if (!userData) {
      
      let tabID = $myDetailsContainer.closest('.accordion-content').attr('id'),
          theTab = $('#' + tabID);
      
      $('#accountAccordion').foundation('down', theTab);

      buildLoyaltyCard(false);

      $('#cardAndBonusDialog .loading').addClass('hide');
      return;
    }
    
    if (userData.birth_date != null) {
      userData.parsed_birth_date = userData.birth_date.split("-").reverse().join('.');
    }

    let data = userData,
        source = $("#my-details-template").html(),
        template = Handlebars.compile(source);

    $('#cardCell').removeClass('hide');

    if (data.suomalainen__kiinnostunut_positiivinen == null || data.suomalainen__kiinnostunut_positiivinen.length === 0) {
      data['no_interests'] = true;
    } else {
      data['no_interests'] = false;
    }

    initMarketingPermissionFields(data);

    if (data.suomalainen__kantisnumero != null) {
      buildLoyaltyCard(data.suomalainen__kantisnumero);
      if (data.loyalty_info != null) {
        buildLoyaltyDiscountInformation(data.loyalty_info);
        buildLoyaltyMagazineBenefits(data?.suomalainen__otavamedia_edut, data.loyalty_info?.level?.level);
      }
    } else {
      buildLoyaltyCard(false);
    }

    $('#cardAndBonusDialog .loading').addClass('hide');

    $myDetailsContainer.html(template(data));

    initChangePasswordSection();

    // Show or hide missing details alert based on fetched data
    if (data.no_interests || !data.phone_number) {
      $('.details-fulfillment').removeClass('hide');
      $('#accountAccordion').foundation('down', $('#omat-tiedot'));
    }
  }

  // Size helper
  Object.size = function(obj) {
    let size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  }

  initChangePasswordSection = function() {
    let $passwordChangeSection = $('#changeAccountPassword'),
        $formContainer = $passwordChangeSection.find('.form-container'),
        $ctaContainer = $passwordChangeSection.find('.cta-container'),
        $ctaButton = $passwordChangeSection.find('#changePasswordCta'),
        $submitButton = $passwordChangeSection.find('#changePasswordSubmit');

    $ctaButton.on('click', function() {
      $ctaContainer.addClass('hidden');
      $formContainer.removeClass('hidden');
    });

    $submitButton.on('click', function() {
      $(this).attr('disabled', 'disabled');
      submitPasswordChange();
    });
  }

  initMarketingPermissionFields = function(data) {
    if (!data.hasOwnProperty('suomalainen__sskk_jasen_nro') || !data.suomalainen__sskk_jasen_nro) {
      $('#sskkMarketingGroup').addClass('marketing-group_hidden');
      $('#sskkMarketingGroup input[type=checkbox]').addClass('marketing-permission-excluded');
      // MAR 2025: SSKK is not accepting new members. Hide the marketing group info.
      //$('#sskkMarketingGroupInfo').removeClass('marketing-group_hidden');
    }

    for (const group in marketingGroups) {
      for (const channel in marketingGroups[group]) {
        const attribute = marketingGroups[group][channel];
        if (channel === 'email') {
          if (data.hasOwnProperty('mailing_lists')) {
            if (data.mailing_lists.includes(attribute)) {
              $('[name="' + attribute + '"]').prop('checked', true);
              marketingPermissionInitialValues[attribute] = true;
            } else {
              marketingPermissionInitialValues[attribute] = false;
            }
          } else {
            marketingPermissionInitialValues[attribute] = false;
          }
        } else {
          if (data.hasOwnProperty(attribute) && data[attribute]) {
            $('[name="' + attribute + '"]').prop('checked', true);
            marketingPermissionInitialValues[attribute] = true;
          } else {
            marketingPermissionInitialValues[attribute] = false;
          }
        }
      }
    }

    $marketingSettingsSubmit.on('click', function() {
      submitMarketingPermissions(data);
    });
  }

  submitMarketingPermissions = function(data) {
    let checkBoxes = $('#marketingSettings input[type=checkbox]'),
        putObj = {
          external_id: data.external_id
        },
        mailingListsAdd = [],
        mailingListsRemove = [];

    checkBoxes.each(function() {
      if ($(this).hasClass('marketing-permission-excluded')) {
        // continue
        return true;
      }

      let attribute = $(this).attr('name'),
          checked = $(this).is(':checked');

      if (checked === marketingPermissionInitialValues[attribute]) {
        // continue
        return true;
      }
      if ($(this).hasClass('email-permission')) {
        if (checked) {
          mailingListsAdd.push(attribute);
        } else {
          mailingListsRemove.push(attribute);
        }
      } else {
        putObj[attribute] = (checked) ? true : false;
      }
    });

    if (mailingListsAdd.length > 0) {
      putObj['mailing_lists.add'] = mailingListsAdd;
    }
    if (mailingListsRemove.length > 0) {
      putObj['mailing_lists.remove'] = mailingListsRemove;
    }

    if (Object.keys(putObj).length > 1 && putObj.external_id) {
      const apiUrl = atp_domain + '/api/omasuomalainen/customers/marketing_permissions';
      let requestData = {
        parameters: {
          customer_id: customer_id,
          email: email,
          shop: shop_domain,
          timestamp: timestamp
        },
        data: putObj
      };

      //console.log(requestData);
      updateMarketingPermissionsResultStatus('loading');

      $.ajax({
        type: "PUT",
        contentType: 'application/json',
        headers: {
          "X-Authorization-Content-SHA256": hmac_digest
        },
        url: apiUrl,
        data: JSON.stringify(requestData),
        success: function() {
          updateMarketingPermissionsInitialValues();
          updateMarketingPermissionsResultStatus('success');
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest);
          updateMarketingPermissionsResultStatus('error');
        }
      });
    }
  }


  updateMarketingPermissionsResultStatus = function(status) {
    let successStatus = $('#marketingSettings .marketing-ajax-messages .success-status'),
        errorStatus = $('#marketingSettings .marketing-ajax-messages .error-status');
    switch(status) {
      case 'loading':
        $marketingSettingsSubmit.prop('disabled', true);
        if (!successStatus.hasClass('hide')) {
          successStatus.addClass('hide');
        }
        if (!errorStatus.hasClass('hide')) {
          errorStatus.addClass('hide');
        }
        break;
      case 'success':
        if (!errorStatus.hasClass('hide')) {
          errorStatus.addClass('hide');
        }
        if (successStatus.hasClass('hide')) {
          successStatus.removeClass('hide');
        }
        $marketingSettingsSubmit.prop('disabled', false);
        break;
      case 'error':
        if (!successStatus.hasClass('hide')) {
          successStatus.addClass('hide');
        }
        if (errorStatus.hasClass('hide')) {
          errorStatus.removeClass('hide');
        }
        $marketingSettingsSubmit.prop('disabled', false);
        break;
    }
  }

  updateMarketingPermissionsInitialValues = function() {
    let checkBoxes = $('#marketingSettings input[type=checkbox]');

    checkBoxes.each(function() {
      if ($(this).hasClass('marketing-permission-excluded')) {
        // continue
        return true;
      }

      let attribute = $(this).attr('name'),
          checked = $(this).is(':checked');

      if (checked === marketingPermissionInitialValues[attribute]) {
        // continue
        return true;
      }
      
      marketingPermissionInitialValues[attribute] = (checked) ? true : false;
    });
  }

  submitPasswordChange = function() {
    theme.helpers.removeErrorMessages();

    theme.helpers.displayLoader({
      submit_text: '#changePasswordSubmit .submit-text',
      loader: '#changePasswordSubmit .loader'
    });
    
    const apiUrl = atp_domain + '/api/omasuomalainen/customers/password_change';
    let requestData = {
      parameters: {
        customer_id: customer_id,
        email: email,
        shop: shop_domain,
        timestamp: timestamp
      },
      data: {
        customer_id: customer_id,
        password: $('#NewPassword').val(),
        password_confirmation: $('#NewPasswordConfirmation').val()
      }
    };

    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      headers: {
        "X-Authorization-Content-SHA256": hmac_digest
      },
      url: apiUrl,
      data: JSON.stringify(requestData),
      success: function() {
        $('#accountChangePasswordForm').addClass('hidden');
        $('#password_change_success').removeClass('hidden');
        setTimeout(function() {
          window.location.reload();
        }, 3000);
      },
      error: function(XMLHttpRequest, textStatus) {
        let responseJson = XMLHttpRequest.responseJSON;
        if (responseJson.response_type === 'invalid_format') {
          $('#password_change_invalid_format').removeClass('hidden');
        } else if (responseJson.response_type === 'missing_required_fields') {
          $('#password_change_missing_fields').removeClass('hidden');
        } else if (responseJson.response_type === 'password_mismatch') {
          $('#password_change_password_mismatch').removeClass('hidden');
        } else {
          $('#password_change_generic_error').removeClass('hidden');
        }
        $('#changePasswordSubmit').removeAttr('disabled');
      },
      complete: function() {
        theme.helpers.hideLoader({
          submit_text: '#changePasswordSubmit .submit-text',
          loader: '#changePasswordSubmit .loader'
        });
      }
    });
  }

  // Build Loyalty card
  buildLoyaltyCard = function(cardNumber) {
    if (cardNumber === false) {
      console.log('NO Card number');
    } else if($('#cardQRCode').length !== 0) {
      new QRCode(document.getElementById('cardQRCode'), {width: 512, height: 512, text: cardNumber.toString()});
      $('.card-number').text(cardNumber);
    }
  }

  buildLoyaltyMagazineBenefits = function(benefits, loyaltyLevel) {
    if (!loyaltyLevel || !benefits || !Array.isArray(benefits) || benefits.length === 0) {
      return;
    }
    
    const container = document.getElementById('loyaltyMagazineLinksContainer');
    const listContainer = container?.querySelector('.loyalty-magazine-links-list');
    
    if (!container || !listContainer) {
      return;
    }

    listContainer.innerHTML = '';

    const linkMap = {
      "HOPEA_DIGI": {
        href: "https://tilaus.otavamedia.fi/hopea",
        text: "Olet ansainnut lehtiedun! Lehtietu sisältää 1kk ilmaisen lukuoikeuden Otavamedian digilehtiin. Voit lunastaa edun Otavamedian tilauspalvelussa klikkaamalla alla olevaa painiketta.",
        title: "Otavamedian digipalvelut 1 kk ilmainen digilukuoikeus"
      },
      "KULTA_DIGI": {
        href: "https://tilaus.otavamedia.fi/kulta",
        text: "Olet ansainnut lehtiedun! Lehtietu sisältää 2kk ilmaisen lukuoikeuden Otavamedian digilehtiin. Voit lunastaa edun Otavamedian tilauspalvelussa klikkaamalla alla olevaa painiketta.",
        title: "Otavamedian digipalvelut 2 kk ilmainen digilukuoikeus"
      },
      "KULTA_PRINTTI": {
        href: "http://tilaus.otavamedia.fi/kultaprintti",
        text: "Olet ansainnut Otavamedian lehtiedun! Lehtietu sisältää kaksi ilmaista printtilehden näytenumeroa. Voit lunastaa edun Otavamedian tilauspalvelussa klikkaamalla alla olevaa painiketta.",
        title: "Kaksi printtilehden näytenumeroa"
      }
    };
    let linksAdded = false;

    benefits.forEach(benefit => {
      if (linkMap[benefit] && benefit.toUpperCase().startsWith(loyaltyLevel.toUpperCase())) {
        const benefitElement = createBenefitElement(linkMap[benefit]);
        listContainer.appendChild(benefitElement);
        linksAdded = true;
      }
    });

    if (linksAdded) {
      container.classList.remove('hide');
    } else {
      container.classList.add('hide');
    }
  }
  
  function createBenefitElement(linkInfo) {
    const titleElement = document.createElement('h6');
    titleElement.textContent = linkInfo.title
    
    const descriptionElement = document.createElement('p')
    descriptionElement.textContent = linkInfo.text
    
    const linkElement = document.createElement('a');
    linkElement.href = linkInfo.href.trim();
    linkElement.target = '_blank';
    linkElement.rel = 'noopener noreferrer';
    linkElement.textContent = "LUNASTA ETU";

    const div = document.createElement('div');
    div.appendChild(titleElement)
    div.appendChild(descriptionElement)
    div.appendChild(linkElement)

    return div
  }

  buildLoyaltyDiscountInformation = function(loyaltyInfo) {
    let loyaltyDiscountsInfo = document.getElementById('loyaltyDiscountInfo');
    if (!loyaltyDiscountsInfo) {
      return;
    }

    let loyaltyLevelImage = document.getElementById('loyaltyLevelImage'),
        loyaltyDiscountLevel = document.getElementById('loyaltyDiscountLevel');
    if (loyaltyInfo.level && loyaltyInfo.level.level) {
      let levelImg = document.createElement('img'),
          loyaltyLevel = loyaltyInfo.level.level.toLowerCase();
      
      levelImg.setAttribute('src', loyaltyInfo.level.level_image);
      loyaltyLevelImage.appendChild(levelImg);
      
      if (loyaltyInfo.level.remaining_for_coupon) {
        loyaltyDiscountLevel.querySelector('.loyalty-coupon-string').textContent = loyaltyInfo.level.remaining_for_coupon;
        loyaltyDiscountLevel.querySelector('.loyaltyRemainingForCoupon').classList.remove('is-hidden');
      }

      let loyaltyRemainingForNextLevel = loyaltyDiscountLevel.querySelector('.loyaltyRemainingForNextLevel');

      if (loyaltyLevel === 'kulta') {
        loyaltyRemainingForNextLevel.parentNode.removeChild(loyaltyRemainingForNextLevel);
        loyaltyDiscountLevel.querySelector('.loyaltyLevelGold').classList.remove('is-hidden');
      } else if (loyaltyInfo.level.remaining_for_next_level) {
        loyaltyDiscountLevel.querySelector('.remaining-for-next-level-price').textContent = loyaltyInfo.level.remaining_for_next_level;
      } else {
        loyaltyRemainingForNextLevel.parentNode.removeChild(loyaltyRemainingForNextLevel);
      }
      
      if (isValidNumber(loyaltyInfo.level.remaining_for_level_keep) && loyaltyInfo.level.remaining_for_level_keep && loyaltyInfo.level.current_level_valid_until) {
        loyaltyDiscountLevel.querySelector('.remaining-for-level-keep-price').textContent = loyaltyInfo.level.remaining_for_level_keep;
        loyaltyDiscountLevel.querySelector('.current-level-valid-until-date').textContent = loyaltyInfo.level.current_level_valid_until;
      } else {
        let loyaltyRemainingForLevelKeep = loyaltyDiscountLevel.querySelector('.loyaltyRemainingForLevelKeep');
        loyaltyRemainingForLevelKeep.parentNode.removeChild(loyaltyRemainingForLevelKeep);
      }

      loyaltyDiscountLevel.classList.remove('is-hidden');
    }

    let atpLoyaltyDiscounts = document.createElement('div');
    atpLoyaltyDiscounts.setAttribute('id', 'atp__loyalty-discounts');

    if (loyaltyInfo.discounts && loyaltyInfo.discounts.length > 0) {
      let len = loyaltyInfo.discounts.length;
      for (let i = 0; i < len; i++) {
        let loyaltyDiscount = document.createElement('div');
        loyaltyDiscount.setAttribute('class', 'loyalty-discount');
        let descriptionText = loyaltyInfo.discounts[i]['description'];
        if (loyaltyInfo.discounts[i].hasOwnProperty('last_day_valid') && loyaltyInfo.discounts[i]['last_day_valid']) {
          descriptionText += ' <b>Etu on voimassa '+ loyaltyInfo.discounts[i]['last_day_valid'] +' asti.</b>';
        }
        let loyaltyDiscountHtml = '<title class="discount-title">'+ loyaltyInfo.discounts[i]['title'] +'</title>\
                                  <p class="discount-description">'+ descriptionText +'</p>';

        if (loyaltyInfo.discounts[i]['code']) {
          loyaltyDiscountHtml += '<p class="discount-code">'+ loyaltyInfo.discounts[i]['code'] +'</p>';
        }

        loyaltyDiscount.innerHTML = loyaltyDiscountHtml;
        atpLoyaltyDiscounts.appendChild(loyaltyDiscount);
      }

    } else {
      let noDiscounts = document.createElement('div');
      noDiscounts.setAttribute('class', 'no-discounts');
      noDiscounts.innerHTML = '<p>Sinulla ei ole tällä hetkellä voimassa olevia asiakaskohtaisia etuja</p>';
      atpLoyaltyDiscounts.appendChild(noDiscounts);
    }

    loyaltyDiscountsInfo.appendChild(atpLoyaltyDiscounts);
  }

  // Customer Bookshelf AJAX loading
  let $bookshelf_item = $('.bookshelf-cell');
  let $bookshelf_item_ids = [];
  $bookshelf_item.each(function() {
    $bookshelf_item_ids.push($(this).attr('id'));
  });

  isValidNumber = function (number) {
    if (!number || typeof number !== 'string') {
      return false;
    }
    let num;
    if (number.indexOf(',') !== -1) {
      num = parseFloat(number.replace(',', '.'));
    } else if (number.indexOf('.') !== -1) {
      num = parseFloat(number);
    } else {
      num = parseInt(number);
    }
    if (isNaN(num) || num == 0) {
      return false;
    }
    return true;
  };

  processProductQueue = function() {
    if ($bookshelf_item_ids.length) {
      let $elementId = $bookshelf_item_ids.shift();
      let $handle = $('#' + $elementId).data('product-handle');
      getProductJSON($handle, $elementId);
    }
  };

  getProductJSON = function(handle, elementId) {
    $.ajax({
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: function(json) {
        populateProductData(json, elementId);
      },
      error: function(res) {
        console.dir(res);
      }
    }).always(function() {
      processProductQueue();
    })
  };

  populateProductData = function(json, elementId) {
    let $bookshelf_item = $('#' + elementId);
    if ($bookshelf_item.find('.product-title a').text() === '') {
      $bookshelf_item.find('.product-title a').text(json.title);
    }
    let authorIndx = -1;
    for (let i = 0; i < json.tags.length; i++) {
      if (json.tags[i].includes('Kirjoittaja:')) {
        authorIndx = i;
        break;
      }
    }
    if (json.featured_image) {
      $bookshelf_item.find('img').attr('src', json.featured_image + '&width=350');
    }
    if (authorIndx > -1) {
      $bookshelf_item.find('.author').text(json.tags[authorIndx].replace('Kirjoittaja:',''));
    }
  }

  $('#accountAccordion').on('down.zf.accordion', function(evt) {
    let evt_target = evt.currentTarget.baseURI;
    if ( evt_target.includes('kirjahylly') ) {
      processProductQueue();
    }
  });

  getUserDetails();
})();
/**
 * Customer Account Edit Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Account Edit
 * template.
 *
 * @namespace customerAccountEdit
 */

theme.customerAccountEdit = (function() {
  var $editDetailsForm = $('#EditDetailsForm'),
      $editDetailsSubmit = $editDetailsForm.find('[type="submit"]'),
      $loadContainer = $('[data-load-container]'),
      $submitResults = $('#submitResult'),
      oldUserData = {},
      debounceTimer = null;

  // Stop executing if no FORM available
  if (!$editDetailsForm.length) {
    return;
  }

  // INPUTS
  var $FirstName        = $('#FirstName'),
      $LastName         = $('#LastName'),
      $StreetAddress    = $('#StreetAddress'),
      $ZipCode          = $('#ZipCode'),
      $City             = $('#City'),
      $Country          = $('#Country'),
      $Phone            = $('#Phone'),
      $BirthDD          = $('#BirthDD'),
      $BirthMM          = $('#BirthMM'),
      $BirthYYYY        = $('#BirthYYYY');

  /**
   * Basic inputs. These are required fields.
   */
  var basicInputs = [
    'email',
    'phone_number',
    'first_name',
    'last_name',
    'street_address',
    'zip_code',
    'city'
  ];

  // ÅLAND FIX
  $('option[value="Aland Islands"]').val('Åland Islands');

  // Format customer parameters
  var customer_id = $('#customerID').val(),
      email = $('#customerEmail').val(),
      external_id = $('#externalID').val(),
      shop_domain = $('#shopDomain').val(),
      timestamp = $('#timestamp').val(),
      hmac_digest = $('#hmac_digest').val(),
      atp_domain = $('#atpDomain').val();

  var customerParamsGet = {
    "external_id": external_id,
    "customer_id": customer_id,
    "email": email,
    "shop": shop_domain,
    "timestamp": timestamp
  };

  var getStr = woolman.jsonToStringHelper(customerParamsGet);

  // Load User data from Custobar
  loadCustobarUser = function() {
    var apiUrl = atp_domain + '/api/omasuomalainen/customers?' + getStr;
    $.ajax({
      type: "GET",
      contentType: 'application/json',
      headers: {
        "X-Authorization-Content-SHA256": hmac_digest
      },
      url: apiUrl,
      data: {},
      dataType: 'json',
      success: function(response_json) {
        //console.log(response_json);
        if (response_json) {
          oldUserData = response_json.customer;
        }
        populateForm(oldUserData);
        hideLoadData();
        $editDetailsForm.removeClass('loading-customer-data');
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log('Jotain män pieleeen');
      }
    });
  }();

  debounce = function(callback, ms) {
    var self = this;
    return function() {
      var context = this, args = arguments;
      clearTimeout(self.debounceTimer);
      self.debounceTimer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  };

  checkEmail = function() {
    var self = this;
    self.debounce(function () {
      var inputEmail = $('#EditDetailsForm #Email').val();

      toggleInputErrorMessage({
        inputName: 'email',
        hasError: false,
        errorType: null
      });

      if (!inputEmail) {
        toggleInputErrorMessage({
          inputName: 'email',
          hasError: true,
          errorType: 'field_missing'
        });
        return;
      }

      if (inputEmail === email) {
        enableEditDetailsSubmit();
        return;
      }

      var requestData = {
        parameters: {
          customer_id: customer_id,
          email: email,
          shop: shop_domain,
          timestamp: timestamp
        },
        data: {
          email: inputEmail
        }
      }

     var apiUrl = atp_domain + '/api/omasuomalainen/customers/email';
     $.ajax({
        type: "POST",
        contentType: 'application/json',
        headers: {
          "X-Authorization-Content-SHA256": hmac_digest
        },
        url: apiUrl,
        data: JSON.stringify(requestData),
        success: function(response_json) {
          toggleInputErrorMessage({
            inputName: 'email',
            hasError: true,
            errorType: 'email_taken'
          });
        },
        error: function(XMLHttpRequest, textStatus) {
          var responseJson = XMLHttpRequest.responseJSON;
          if (XMLHttpRequest.status != 404) {
            if (responseJson.response_type === 'invalid_format') {
              toggleInputErrorMessage({
                inputName: 'email',
                hasError: true,
                errorType: 'invalid_format'
              });
            } else {
              $('.updating').removeClass('hidden');
              updateResultStatus('error', 'common');
            }
          } else {
            enableEditDetailsSubmit();
          }
        }
      });
    }, 650)();
  };

  checkPhoneNumber = function() {
    var self = this;
    self.debounce(function () {
      var inputPhone = $Phone.val();

      toggleInputErrorMessage({
        inputName: 'phone_number',
        hasError: false,
        errorType: null
      });

      if (!inputPhone) {
        toggleInputErrorMessage({
          inputName: 'phone_number',
          hasError: true,
          errorType: 'field_missing'
        });
        return;
      }

      inputPhone = convertPhoneNumber(inputPhone);

      if (!inputPhone) {
        toggleInputErrorMessage({
          inputName: 'phone_number',
          hasError: true,
          errorType: 'invalid_format'
        });
        return;
      }

      if (inputPhone === oldUserData.phone_number) {
        enableEditDetailsSubmit();
        return;
      }

      var allowedMinLength = (inputPhone.length >= 5) ? true : false;
      if (!allowedMinLength) {
        toggleInputErrorMessage({
          inputName: 'phone_number',
          hasError: true,
          errorType: 'phone_too_short'
        });
        return;
      }

      var allowedMaxLength = (inputPhone.length <= 17) ? true : false;
      if (!allowedMaxLength) {
        toggleInputErrorMessage({
          inputName: 'phone_number',
          hasError: true,
          errorType: 'phone_too_long'
        });
        return;
      }

      let requestData = {
        parameters: {
          customer_id: customer_id,
          email: email,
          shop: shop_domain,
          timestamp: timestamp
        },
        data: {
          phone_number: inputPhone
        }
      }

      var apiUrl = atp_domain + '/api/omasuomalainen/customers/phone_number';
      $.ajax({
        type: "POST",
        contentType: 'application/json',
        headers: {
          "X-Authorization-Content-SHA256": hmac_digest
        },
        url: apiUrl,
        data: JSON.stringify(requestData),
        success: function(response_json) {
          toggleInputErrorMessage({
            inputName: 'phone_number',
            hasError: true,
            errorType: 'phone_taken'
          });
        },
        error: function(XMLHttpRequest, textStatus) {
          let responseJson = XMLHttpRequest.responseJSON;
          if (XMLHttpRequest.status != 404) {
            if (responseJson.response_type === 'invalid_format') {
              toggleInputErrorMessage({
                inputName: 'phone_number',
                hasError: true,
                errorType: 'invalid_format'
              });
            } else {
              $('.updating').removeClass('hidden');
              updateResultStatus('error', 'common');
            }
          } else {
            enableEditDetailsSubmit();
          }
        }
      });
    }, 650)();
  };

  validatePhoneNumber = function(callback) {
    var inputPhone = $Phone.val();

    toggleInputErrorMessage({
      inputName: 'phone_number',
      hasError: false,
      errorType: null
    });

    if (!inputPhone) {
      toggleInputErrorMessage({
        inputName: 'phone_number',
        hasError: true,
        errorType: 'field_missing'
      });
      return;
    }

    inputPhone = convertPhoneNumber(inputPhone);

    if (!inputPhone) {
      toggleInputErrorMessage({
        inputName: 'phone_number',
        hasError: true,
        errorType: 'invalid_format'
      });
      return;
    }

    var allowedMinLength = (inputPhone.length >= 5) ? true : false;
    if (!allowedMinLength) {
      toggleInputErrorMessage({
        inputName: 'phone_number',
        hasError: true,
        errorType: 'phone_too_short'
      });
      return;
    }

    var allowedMaxLength = (inputPhone.length <= 17) ? true : false;
    if (!allowedMaxLength) {
      toggleInputErrorMessage({
        inputName: 'phone_number',
        hasError: true,
        errorType: 'phone_too_long'
      });
      return;
    }

    let requestData = {
      parameters: {
        customer_id: customer_id,
        email: email,
        shop: shop_domain,
        timestamp: timestamp
      },
      data: {
        phone_number: inputPhone
      }
    }

    var apiUrl = atp_domain + '/api/omasuomalainen/customers/phone_number/validate';
    $.ajax({
      type: "POST",
      contentType: 'application/json',
      headers: {
        "X-Authorization-Content-SHA256": hmac_digest
      },
      url: apiUrl,
      data: JSON.stringify(requestData),
      success: function(response_json) {
        if (callback) {
          callback();
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        let responseJson = XMLHttpRequest.responseJSON;
        if (responseJson.response_type === 'invalid_format') {
          toggleInputErrorMessage({
            inputName: 'phone_number',
            hasError: true,
            errorType: 'invalid_format'
          });
        } else {
          $('.updating').removeClass('hidden');
          updateResultStatus('error', 'common');
        }
      }
    });
  };

  checkTextInputField = function(input) {
    var self = this;
    self.debounce(function () {
      var value = input.val(),
          name = input.attr('name');

      if (!value) {
        toggleInputErrorMessage({
          inputName: name,
          hasError: true,
          errorType: 'field_missing'
        });
        return;
      }

      toggleInputErrorMessage({
        inputName: name,
        hasError: false,
        errorType: null
      });

      enableEditDetailsSubmit();
    }, 500)();
  };

  toggleInputErrorMessage = function(input) {
    var inputElement = $('#EditDetailsForm input[name="' + input.inputName + '"]');
    var label = inputElement.closest('label');
    if (input.hasError) {
      label.addClass('is-invalid-label');
      inputElement.addClass('is-invalid-input');
      label.find('.form-error.' + input.errorType).addClass('is-visible');
    } else {
      label.removeClass('is-invalid-label');
      inputElement.removeClass('is-invalid-input');
      label.find('.form-error').removeClass('is-visible');
    }
  };

  clearAllInputErrors = function() {
    var inputElements = $('#EditDetailsForm input');
    var labels = $('#EditDetailsForm label');
    labels.removeClass('is-invalid-label');
    inputElements.removeClass('is-invalid-input');
    labels.find('.form-error').removeClass('is-visible');
  };

  // Hide Load message
  hideLoadData = function() {
    $loadContainer.animate({
      opacity: 0
    }, 500, function() {
      $loadContainer.hide();
    });
  };

  // Populates form with customer data
  populateForm = function(userData) {
    if (!userData) {
      return;
    }

    /**
     * Populate basic inputs.
     * Show field_missing error if field is missing.
     */
    basicInputs.forEach(function(key) {
      if (key in userData && userData[key].length) {
        var $input = $('[name="' + key + '"]');
        $input.val(userData[key]);
      } else {
        toggleInputErrorMessage({
          inputName: key,
          hasError: true,
          errorType: 'field_missing'
        });
      }
    });

    if (userData['phone_number']) {
      setSelectedCountry(userData['phone_number']);
    }

    $Country.on('change', function() {
      checkPhoneNumber();
    });

    // Birthdate
    if(userData['birth_date']) {
      var birthDateArray = userData['birth_date'].split('-');
      $BirthYYYY.val(birthDateArray[0]);
      $BirthMM.val(birthDateArray[1]);
      $BirthDD.val(birthDateArray[2]);
    }

    // Interests

    /* New interests */
    var customerInterestsList;
    const customerInterestsListUrl = $('#customerInterestsListUrl').val();

    async function fetchInterestsList() {
      try {
        const response = await fetch(customerInterestsListUrl);
        return await response.json();
      } catch (error) {
        console.error("Error fetching interests data:", error);
        return null;
      }
    }
    fetchInterestsList().then((interestsList) => {
      if (interestsList) {
        customerInterestsList = interestsList;
        buildInterestsForm(customerInterestsList);
      } else {
        console.log("Failed to fetch interests data");
      }
    });

    /* icons */
    const thumbsUpIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path d="M20.22 9.55C19.79 9.04 19.17 8.75 18.5 8.75H14.47V6C14.47 4.48 13.24 3.25 11.64 3.25C10.94 3.25 10.31 3.67 10.03 4.32L7.49 10.25H5.62C4.31 10.25 3.25 11.31 3.25 12.62V18.39C3.25 19.69 4.32 20.75 5.62 20.75H17.18C18.27 20.75 19.2 19.97 19.39 18.89L20.71 11.39C20.82 10.73 20.64 10.06 20.21 9.55H20.22ZM5.62 19.25C5.14 19.25 4.75 18.86 4.75 18.39V12.62C4.75 12.14 5.14 11.75 5.62 11.75H7.23V19.25H5.62ZM17.92 18.63C17.86 18.99 17.55 19.25 17.18 19.25H8.74V11.15L11.41 4.9C11.45 4.81 11.54 4.74 11.73 4.74C12.42 4.74 12.97 5.3 12.97 5.99V10.24H18.5C18.73 10.24 18.93 10.33 19.07 10.5C19.21 10.67 19.27 10.89 19.23 11.12L17.91 18.62L17.92 18.63Z" fill="#000000"/>
            </svg>`;

    const thumbsDownIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path d="M18.38 3.25H6.81C5.72 3.25 4.79 4.03 4.6 5.11L3.29 12.61C3.18 13.27 3.36 13.94 3.78 14.45C4.21 14.96 4.83 15.25 5.5 15.25H9.53V18C9.53 19.52 10.76 20.75 12.36 20.75C13.06 20.75 13.69 20.33 13.97 19.68L16.51 13.75H18.39C19.7 13.75 20.76 12.69 20.76 11.38V5.61C20.76 4.31 19.7 3.25 18.39 3.25H18.38ZM15.26 12.85L12.59 19.1C12.55 19.19 12.46 19.26 12.27 19.26C11.58 19.26 11.03 18.7 11.03 18.01V13.76H5.5C5.27 13.76 5.07 13.67 4.93 13.5C4.78 13.33 4.73 13.11 4.77 12.88L6.08 5.38C6.14 5.02 6.45001 4.76 6.82 4.76H15.26V12.85ZM19.25 11.38C19.25 11.86 18.86 12.25 18.38 12.25H16.77V4.75H18.38C18.86 4.75 19.25 5.14 19.25 5.61V11.38Z" fill="#000000"/>
            </svg>`;
    
    const neutralIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" width="20px" height="20px" viewBox="0 0 36 36" version="1.1" preserveAspectRatio="xMidYMid meet">
            <path d="M24.05,22.06h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2Z" class="clr-i-outline clr-i-outline-path-1"/><path d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm0,30A14,14,0,1,1,32,18,14,14,0,0,1,18,32Z" class="clr-i-outline clr-i-outline-path-2"/><circle cx="25.16" cy="14.28" r="1.8" class="clr-i-outline clr-i-outline-path-3"/><circle cx="11.16" cy="14.28" r="1.8" class="clr-i-outline clr-i-outline-path-4"/>
            <rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
            </svg>`;
    
    /* build new interests */
    function buildInterestsForm(customerInterestsList) {
      for (const interest of customerInterestsList) {
      const categoryDiv = document.createElement("div");
      categoryDiv.setAttribute("class", "category");
    
      // Add buttons for each category
      const categoryButtonsDiv = document.createElement("div");
      categoryButtonsDiv.setAttribute("class", "category-buttons");
    
      const loadingSpan = document.createElement("span");
      loadingSpan.setAttribute("class", "animated-loading");
      categoryButtonsDiv.appendChild(loadingSpan);
    
      const interestName = document.createElement("h3");
      interestName.textContent = interest.name;
      interestName.classList.add("category-title");
      categoryButtonsDiv.appendChild(interestName);
    
      // Add counter spans for interests, not-interests, and neutral
      const counterSpan = document.createElement("span");
      counterSpan.setAttribute("class", "counter");
      const interestsSpan = document.createElement("span");
      interestsSpan.classList.add("counter-interested");
      const neutralSpan = document.createElement("span");
      neutralSpan.classList.add("counter-neutral");
      const notInterestsSpan = document.createElement("span");
      notInterestsSpan.classList.add("counter-not-interested");
      counterSpan.appendChild(interestsSpan);
      counterSpan.appendChild(neutralSpan);
      counterSpan.appendChild(notInterestsSpan);
      categoryButtonsDiv.appendChild(counterSpan);
    
      categoryDiv.appendChild(categoryButtonsDiv);
    
      const fieldset = document.createElement("fieldset");
    
      const subCategoriesDiv = document.createElement("div");
      subCategoriesDiv.setAttribute(
        "class",
        "sub-categories interests-subcategories"
      );
      for (const subCategory of interest.subCategories) {
        const subFieldset = document.createElement("fieldset");

        const interestedInput = document.createElement("input");
        interestedInput.setAttribute(
          "class",
          "interests-subcategory checkbox-button interested"
        );
        interestedInput.setAttribute("type", "checkbox");
        interestedInput.setAttribute("name", subCategory.dataString);
        interestedInput.setAttribute("value", "interested");
        interestedInput.setAttribute(
        "id",
        `${subCategory.displayString
          .toLowerCase()
          .replace(/ /g, "")}_interested`
        );
        subFieldset.appendChild(interestedInput);

        const interestedLabel = document.createElement("label");
        interestedLabel.setAttribute(
          "for",
          `${subCategory.displayString
            .toLowerCase()
            .replace(/ /g, "")}_interested`
        );
        interestedLabel.innerHTML = thumbsUpIcon;
        subFieldset.appendChild(interestedLabel);

        const neutralInput = document.createElement("input");
        neutralInput.setAttribute(
          "class",
          "interests-subcategory checkbox-button neutral"
        );
        neutralInput.setAttribute("type", "checkbox");
        neutralInput.setAttribute("name", subCategory.dataString);
        neutralInput.setAttribute("value", "neutral");
        neutralInput.setAttribute(
          "id",
          `${subCategory.displayString.toLowerCase().replace(/ /g, "")}_neutral`
        );
        subFieldset.appendChild(neutralInput);

        const neutralLabel = document.createElement("label");
        neutralLabel.setAttribute(
          "for",
          `${subCategory.displayString.toLowerCase().replace(/ /g, "")}_neutral`
        );
        neutralLabel.innerHTML = neutralIcon;
        subFieldset.appendChild(neutralLabel);

        const notInterestedInput = document.createElement("input");
        notInterestedInput.setAttribute(
          "class",
          "interests-subcategory checkbox-button not-interested"
        );
        notInterestedInput.setAttribute("type", "checkbox");
        notInterestedInput.setAttribute("name", subCategory.dataString);
        notInterestedInput.setAttribute("value", "not_interested");
        notInterestedInput.setAttribute(
          "id",
          `${subCategory.displayString
            .toLowerCase()
            .replace(/ /g, "")}_not_interested`
        );
        subFieldset.appendChild(notInterestedInput);

        const notInterestedLabel = document.createElement("label");
        notInterestedLabel.setAttribute(
          "for",
          `${subCategory.displayString
            .toLowerCase()
            .replace(/ /g, "")}_not_interested`
        );
        notInterestedLabel.innerHTML = thumbsDownIcon;
        subFieldset.appendChild(notInterestedLabel);

        const subLegend = document.createElement("span");
        subLegend.textContent = subCategory.displayString;
        subLegend.classList.add("subcategory-title");
        subFieldset.appendChild(subLegend);

        subCategoriesDiv.appendChild(subFieldset);
      }
      fieldset.appendChild(subCategoriesDiv);
      categoryDiv.appendChild(fieldset);
      document.getElementById("customerInterestsFieldset").appendChild(categoryDiv);
      const categoryDivs = document.querySelectorAll(".category");
      setTimeout(() => {
        categoryDivs.forEach((div) => {
          div.classList.add("loaded");               
        });
        populateInterests(userData);
      }, 500);

      // Update counters based on selected subcategories
      const subCategoryInputs = categoryDiv.querySelectorAll(
        '.interests-subcategory[type="checkbox"]'
      );
      subCategoryInputs.forEach((input) => {
        input.addEventListener("change", () => {
        // Uncheck the other input when one is checked
        const otherOptions = input.parentNode.querySelectorAll(
          `.interests-subcategory[type="checkbox"]:checked:not([value="${input.value}"])`
        );
        otherOptions.forEach((option) => {
          option.checked = false;
        });

        const categoryDiv = input.closest(".category");
        const interestsCounter = categoryDiv.querySelector(
          ".counter-interested"
        );
        const notInterestsCounter = categoryDiv.querySelector(
          ".counter-not-interested"
        );
        const neutralCounter = categoryDiv.querySelector(".counter-neutral");
        const selectedInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="interested"]:checked'
        );
        const selectedNotInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="not_interested"]:checked'
        );
        const selectedNeutral = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="neutral"]:checked'
        );

        if (selectedInterests.length > 0) {
          interestsCounter.innerHTML = `${selectedInterests.length}${thumbsUpIcon}`;
        } else {
          interestsCounter.innerHTML = "";
        }

        if (selectedNotInterests.length > 0) {
          notInterestsCounter.innerHTML = `${selectedNotInterests.length}${thumbsDownIcon}`;
        } else {
          notInterestsCounter.innerHTML = "";
        }

        if (selectedNeutral.length > 0) {
          neutralCounter.innerHTML = `${selectedNeutral.length}${neutralIcon}`;
        } else {
          neutralCounter.innerHTML = "";
        }
        });
      });
      }

      // Show the subcategories when the category button is clicked
      const categoryButtons = document.querySelectorAll(".category-buttons");
      categoryButtons.forEach((categoryButton) => {
        categoryButton.addEventListener("click", () => {
          const fieldset = categoryButton.nextElementSibling;
          fieldset.classList.toggle("show-interests-subcategories");
          categoryButton.classList.toggle("open");

          // Close other subcategories
          const otherFieldsets = document.querySelectorAll(
            ".show-interests-subcategories"
          );
          otherFieldsets.forEach((otherFieldset) => {
          if (otherFieldset !== fieldset) {
            otherFieldset.classList.remove("show-interests-subcategories");
            const otherCategoryButton = otherFieldset.previousElementSibling;
            otherCategoryButton.classList.remove("open");
          }
          });
        });
      });
    }

    // Populate new interests
    function populateInterests(userData) {
      if ('suomalainen__kiinnostunut_positiivinen' in userData) {
        var userInterestsPositive = userData['suomalainen__kiinnostunut_positiivinen'];
        userInterestsPositive.forEach(function(interest) {
          var input = document.querySelector(`input[name="${interest}"][value="interested"]`);
          if (input) {
            input.checked = true;
          }     
        });
      };
      if ('suomalainen__kiinnostunut_negatiivinen' in userData) {
        var userInterestsNegative = userData['suomalainen__kiinnostunut_negatiivinen'];
        userInterestsNegative.forEach(function(interest) {
          var input = document.querySelector(`input[name="${interest}"][value="not_interested"]`);
          if (input) {
            input.checked = true;
          }
        });
      };
      updateCounters();
    }

    // Update counters after populating interests
    function updateCounters() {
      const categoryDivs = document.querySelectorAll(".category");
      categoryDivs.forEach((categoryDiv) => {
        const interestsCounter = categoryDiv.querySelector(".counter-interested");
        const notInterestsCounter = categoryDiv.querySelector(".counter-not-interested");
        const neutralCounter = categoryDiv.querySelector(".counter-neutral");
        const selectedInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="interested"]:checked'
        );
        const selectedNotInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="not_interested"]:checked'
        );
        const selectedNeutral = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="neutral"]:checked'
        );
        if (selectedInterests.length > 0) {
          interestsCounter.innerHTML = `${selectedInterests.length}${thumbsUpIcon}`;
        }
        if (selectedNotInterests.length > 0) {
          notInterestsCounter.innerHTML = `${selectedNotInterests.length}${thumbsDownIcon}`;
        }
        if (selectedNeutral.length > 0) {
          neutralCounter.innerHTML = `${selectedNeutral.length}${neutralIcon}`;
        }
      });
    }

    // Country
    /*
    if ('country' in userData) {
      isoCountries = JSON.parse($('[data-iso-countries-json]').html());
      var user_country = userData['country'],
          country_val = isoCountries.iso_3166_1[user_country];
      $('#Country').val(country_val);
    }
    */

    $('#EditDetailsForm #Email').on('input', function() {
      if (!$editDetailsSubmit.prop('disabled')) {
        $editDetailsSubmit.attr('disabled', 'disabled');
      }
      checkEmail();
    });

    $('#EditDetailsForm #Phone').on('input', function() {
      if (!$editDetailsSubmit.prop('disabled')) {
        $editDetailsSubmit.attr('disabled', 'disabled');
      }
      checkPhoneNumber();
    });

    $('#EditDetailsForm input[type="text"]').on('input', function() {
      if (!$editDetailsSubmit.prop('disabled')) {
        $editDetailsSubmit.attr('disabled', 'disabled');
      }
      checkTextInputField($(this));
    });
  };

  enableEditDetailsSubmit = function() {
    var enable = true,
        len = basicInputs.length;
    for (var i = 0; i < len; i++) {
      var key = basicInputs[i],
          $input = $('[name="' + key + '"]');
      if ($input.hasClass('is-invalid-input')) {
        enable = false;
        break;
      }
    }
    if (enable) {
      $editDetailsSubmit.removeAttr('disabled');
    }
  };

  // Parses the form data to custobar object format
  parseFormData = function(formData) {
    let newUserData = {},
        interestArray = [],
        interestPositiveArray = [],
        interestNegativeArray = [],
        birthDateHolder = ['nan','nan','nan'];
    
    formData.forEach(function(arrayObject) {
      switch(arrayObject.name) {
        case 'email':
          newUserData[arrayObject.name] = arrayObject.value;
          break;
        case 'phone_number':
          newUserData[arrayObject.name] = convertPhoneNumber(arrayObject.value);
          break;
        case 'country':
          // do not send country field to server
          delete newUserData[arrayObject.name];
          break;
        case 'suomalainen__kiinnostunut':
          interestArray.push(arrayObject.value);
          break;
        case 'birth_dd':
          birthDateHolder[2] = arrayObject.value;
          break;
        case 'birth_mm':
          birthDateHolder[1] = arrayObject.value;
          break;
        case 'birth_yyyy':
          birthDateHolder[0] = arrayObject.value;
          break;
        default:
          if (arrayObject.value === 'interested') {
            interestPositiveArray.push(arrayObject.name); // Customer interests positive
          } else if (arrayObject.value === 'not_interested') {
            interestNegativeArray.push(arrayObject.name); // Customer interests negative
          } else if (arrayObject.value === 'true') {
            newUserData[arrayObject.name] = true;
          } else if (arrayObject.value === 'false') {
            newUserData[arrayObject.name] = false;
          } else if (arrayObject.value !== '') {
            newUserData[arrayObject.name] = arrayObject.value;
          } else if (arrayObject.value.length === 0 || arrayObject.value.indexOf('-') > 0) {
            newUserData[arrayObject.name] = '';
          }
      }
    });

    const theBirthDay = birthDateHolder.join('-'),
          containsNumber = /\d/.test(theBirthDay);

    if (!containsNumber) {
      newUserData['birth_date'] = '';
    } else {
      if (theBirthDay.indexOf('--') === -1) {
        newUserData['birth_date'] = theBirthDay;
      }
    }
    if (interestArray.length > 0) {
      newUserData['suomalainen__kiinnostunut'] = interestArray;
    } else {
      newUserData['suomalainen__kiinnostunut'] = [];
    }
    if (interestPositiveArray.length > 0) {
      newUserData['suomalainen__kiinnostunut_positiivinen'] = interestPositiveArray;
    } else {
      newUserData['suomalainen__kiinnostunut_positiivinen'] = [];
    }
    if (interestNegativeArray.length > 0) {
      newUserData['suomalainen__kiinnostunut_negatiivinen'] = interestNegativeArray;
    } else {
      newUserData['suomalainen__kiinnostunut_negatiivinen'] = [];
    }

    return newUserData;
  };

  // SUBMIT
  $editDetailsForm.on('submit', function(e) {
    e.preventDefault();
    validatePhoneNumber(sendCustomerPutRequest);
  });

  sendCustomerPutRequest = function() {
    clearAllInputErrors();
    $editDetailsSubmit.attr('disabled', 'disabled');
    updateResultStatus('loading');

    const customerArray = $editDetailsForm.serializeArray(),
          apiUrl = atp_domain + '/api/omasuomalainen/customers',
          originalEmail = (oldUserData.hasOwnProperty('email')) ? oldUserData.email : null,
          originalPhoneNumber = (oldUserData.hasOwnProperty('phone_number')) ? oldUserData.phone_number : null;

    const requestData = {
      parameters: {
        customer_id: customer_id,
        email: email,
        phone_number: originalPhoneNumber,
        old_email: originalEmail,
        shop: shop_domain,
        timestamp: timestamp
      },
      data: Object.assign({'external_id': external_id}, parseFormData(customerArray))
    };

    $.ajax({
      type: "PUT",
      contentType: 'application/json',
      headers: {
        "X-Authorization-Content-SHA256": hmac_digest
      },
      url: apiUrl,
      data: JSON.stringify(requestData),
      success: function() {
        updateResultStatus('success');
      },
      error: function(XMLHttpRequest, textStatus) {
        const responseJson = XMLHttpRequest.responseJSON;
        if (responseJson.response_type === 'invalid_format') {
          $('.updating').addClass('hidden');
          $submitResults.addClass('hide');
          highlightMissingInvalidFields({
            missing: null,
            invalid: responseJson.invalid_fields
          });
        } else if (responseJson.response_type === 'missing_required_fields') {
          $('.updating').addClass('hidden');
          $submitResults.addClass('hide');
          highlightMissingInvalidFields({
            missing: responseJson.required_fields,
            invalid: null
          });
        } else {
          if (XMLHttpRequest.status == 400) {
            updateResultStatus('error', 400);
          } else if (XMLHttpRequest.status == 422) {
            updateResultStatus('error', 422);
          } else {
            updateResultStatus('error', 'common');
          }
        }
        $editDetailsSubmit.removeAttr('disabled');
      }
    });
  };

  highlightMissingInvalidFields = function(fields) {
    if (fields.missing) {
      fields.missing.forEach(function(field, index) {
        toggleInputErrorMessage({
          inputName: field,
          hasError: true,
          errorType: 'missing_field'
        });
      });
    }

    if (fields.invalid) {
      fields.invalid.forEach(function(field, index) {
        toggleInputErrorMessage({
          inputName: field,
          hasError: true,
          errorType: 'invalid_format'
        });
      });
    }
  };

  updateResultStatus = function(statusMessage, code) {
    switch(statusMessage) {
      case 'success':
        $submitResults.find('> div').addClass('hide');
        $submitResults.find('.success-status').removeClass('hide');

        var redirNum = 5;
        var redirElem =  $submitResults.find('.redirect');
        var redirTimer = setInterval(function() {
          --redirNum;
          if (redirNum > 0) {
            redirElem.text('Sinut ohjataan takaisin ' + redirNum + ' sekunnin kuluttua.');
          } else {
            clearInterval(redirTimer);
            redirElem.html('<span class="text-center loading animated"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" x="0px" y="0px" viewBox="0 0 30 30"><circle class="dot-1" cx="5" cy="15" r="3"/><circle class="dot-2" cx="15" cy="15" r="3"/><circle class="dot-3" cx="25" cy="15" r="3"/></svg></span>');
            window.location.href = "/account#omat-tiedot";
          }
        }, 1000);

        break;
      case 'error':
        $errorP = $submitResults.find('.error-status .error');
        errorMsg = $errorP.data('error-' + code);
        $errorP.text(errorMsg);
        $submitResults.find('> div').addClass('hide');
        $submitResults.find('.error-status').removeClass('hide');
        $submitResults.removeClass('hide');
        break;
      case 'loading':
        $('.updating').removeClass('hidden');
        $submitResults.removeClass('hide');
        break;
    }
  }

  convertPhoneNumber = function(phoneNumber) {
    if (!phoneNumber) {
      return null;
    }
    var phone = phoneNumber.trim().replace(/\s+/g, '').replace(/-/g, ''),
        code = '+' + $Country.val();
    if (phone.substring(0, code.length) !== code) {
      if (phone.indexOf('+') !== -1) {
        return null;
      } else if (phone.charAt(0) === '0') {
        phone = code + phone.substring(1);
      } else {
        phone = code + phone;
      }
    }
    return phone;
  }

  setSelectedCountry = function(phoneNumber) {
    var phone = phoneNumber.trim().replace(/\s+/g, '').replace(/-/g, '');
    if (phone.charAt(0) === '+') {
      [].forEach.call(document.querySelectorAll('#Country .country-item'), function(option) {
        var code = '+' + option.value;
        if (phone.substring(0, code.length) == code) {
          $Country.val(option.value).change();
        }
      });
    }
  }
})();

// Audio Services javascript modals.
var $asModalTrigger = $('a[data-js-action="openModal"]');
$asModalTrigger.click(function(evt) { 
  if ( !$(this).data('js-action') ) { return };
  evt.preventDefault();
  $(this).addClass('hasModal');
  var asModalJSON = JSON.parse($('script' + $(this).attr('href')).html()),
      details = asModalJSON.details[0];

  // Reorganize data of the JSON object
  if ( details.Duration ) {
    var days = details.Duration.slice(0,1),
        hours = details.Duration.slice(1,3),
        minutes = details.Duration.slice(3,5),
        seconds = details.Duration.slice(5,7),
        timestamp = [];
    
    if ( days != '0' ) {
      timestamp.push(days + 'd')
    }
    if ( hours != '00' ) {
      timestamp.push(hours + 'h')
    }
    if ( minutes != '00' ) {
      timestamp.push(minutes + 'min')
    }
    if ( seconds != '00' ) {
      timestamp.push(seconds + 'sec')
    }

    details.Duration = timestamp.join(" ");
  }
  asModalJSON.subtitle = details.Subtitle;
  asModalJSON.details = details;

  if ( asModalJSON.type === 'Äänikirja' ) {
    asModalJSON.audiobook = true;
  } else if ( asModalJSON.type === 'E-kirja' ) {
    asModalJSON.aspect_ratio = 'portrait';
  }

  // Init Handlebars
  var $asModalSource = $('#ajax-audioservice-modal').html(),
      $asModalTemplate = Handlebars.compile($asModalSource),
      $asModalContent = $('[data-audioservice-modal]');

  $asModalContent.html($asModalTemplate(asModalJSON)).foundation('open');

  //For opening email pop up instead of normal behaviour
  $('div[data-audioservice-modal] a').click(function(evt){
    if ( $(this).attr('disabled') ) { return };
    if ( $(this).attr('href') != productPlus14Link ) { return };
    evt.preventDefault();
  
    var $productPopup = $('[data-audioservice-modal]');
    $productPopup.foundation('close');
  
    var $emailPopup = $('[data-audioservice-email-popup]');
    $emailPopup.foundation('open');
  });
});
// Duration JS filter for Kirjavinkit page.
$('[data-duration]').each(function() {
  var duration = $(this).data('duration');

  var days = duration.slice(0,1),
      hours = duration.slice(1,3),
      minutes = duration.slice(3,5),
      seconds = duration.slice(5,7),
      timestamp = [];
    
  if ( days != '0' ) {
    timestamp.push(days + 'd')
  }
  if ( hours != '00' ) {
    timestamp.push(hours + 'h')
  }
  if ( minutes != '00' ) {
    timestamp.push(minutes + 'min')
  }
  if ( seconds != '00' ) {
    timestamp.push(seconds + 'sec')
  }

  $(this).html(timestamp.join(" "));
});

// Collection page sorting
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }

  if ( Shopify.queryParams.sort_by ) {  
    $('#Audioservice-SortBy').val(Shopify.queryParams.sort_by)
  }
}

$('#Audioservice-SortBy').bind('change', function() {
  Shopify.queryParams.sort_by = jQuery(this).val();
  location.search = jQuery.param(Shopify.queryParams);
});
woolman.init = function() {
  woolman.cacheSelectors();
  woolman.responsiveVideos();
  woolman.scrollTo();
  woolman.productCardSizes();
  woolman.collectionSort();

  woolman.productImageSwitch();
  woolman.ajaxCartInit();

  // SEARCH
  //woolman.quickSearchInit();
  //woolman.parseDefaultSearch();
};

$(document).ready(function() {

  let previousFocus = null;
  const $menuTrigger = $('[data-toggle="sidebar"]');
  
  $('.slideshow-banner').on('setPosition', function() {
      const responsiveImages = document.getElementsByClassName('custom-responsive');
      switchLargeImage(responsiveImages);
      window.addEventListener('resize', function(event) {
        // Add timeout to switch image size to prevent stuttering
        setTimeout(() => { switchLargeImage(responsiveImages); }, 100);
      }, true);
  });

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('slideshow', theme.SlideshowSection);

  // Jumping SlickJS slideshow element fix
  // First we show the preview image (= first image of the slideshow),
  // then after all the images have loaded, remove
  // preview image and display the slideshow element
  $('.slideshow-banner').each(function() {
    var banner = $(this);
    var preview = banner.prev('.slideshow-preview');
    var slideshowImages = $(this).find('img');
    var slideshowImagesCount = slideshowImages.length;
    var loadedImagesCount = 0;
    slideshowImages.each(function(index) {
      $(this).on('load', function() {
      loadedImagesCount++;
      if (loadedImagesCount === slideshowImagesCount) {
        banner.css('display', 'block');
        banner.slick('setPosition');
        preview.remove();
      }
      if (loadedImagesCount >= slideshowImagesCount) {
        $(this).off('load'); // Remove the onload event listener
      }
      });
    });
  });

  // Check screen size and use larger image if needed
  function switchLargeImage(elements) {
    if (elements.length > 0) {
      for (var i = 0; i < elements.length; i++) {

        // Switch image src with data-image on mobile -> desktop
        if ( screen.width >= 640 ) {
          dataImage = elements[i].getAttribute('data-image-large');
        } else {
          dataImage = elements[i].getAttribute('data-image-mobile');
        }
        if ( elements[i].src !== dataImage) {
          elements[i].src = dataImage;
        }
      }
    }
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="youtube-nocookie.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Slider accessibility strings
  let accessibilitySlideLeft = document.querySelector("#accessibilityStrings").getAttribute("data-slide-left");
	let accessibilitySlideRight = document.querySelector("#accessibilityStrings").getAttribute("data-slide-right");
  let slideLeftButton = '<button type="button" aria-label="' + accessibilitySlideLeft + '" class="slick-prev unstyled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="444" d="M3.45 10c0-.2.1-.3.21-.5L13.19.2a.82.82 0 0 1 .52-.2c.2 0 .3.1.51.2l1 1a.72.72 0 0 1 .21.5c0 .2-.21.3-.31.4L7.14 10l8.1 7.86a.72.72 0 0 1 .21.5c0 .2-.1.3-.21.5l-1 1a.79.79 0 0 1-.51.2c-.21 0-.31-.1-.52-.2L3.66 10.55A.82.82 0 0 1 3.45 10Z"/></svg></button>';
  let slideRightButton = '<button type="button" aria-label="' + accessibilitySlideRight + '" class="slick-next unstyled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 10.5 6.36 19.8a.82.82 0 0 1-.52.2c-.2 0-.3-.1-.51-.2l-1-1a.72.72 0 0 1-.21-.5c0-.2.1-.3.21-.5l8.1-7.9-8-7.8a.78.78 0 0 1-.21-.4 1.78 1.78 0 0 1 .21-.5l1-1A.82.82 0 0 1 5.84 0a.82.82 0 0 1 .52.2l9.53 9.3a.72.72 0 0 1 .21.5A.54.54 0 0 1 15.89 10.5Z"/></svg></svg></button>';

  // NOTIFICATION BAR Slider.
  $('.notification-slideshow').not('.slick-initialized, .wide-product-slider').slick({
    lazyLoad: "ondemand",
    mobileFirst: true,
    autoplay: false,
    speed: 600,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: slideLeftButton,
    nextArrow: slideRightButton,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 800,
        }
      }
      ,
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 1000,
        }
      }
    ]
  });  

  // PRODUCTS COLLECTION Slider.   
  $('.product-slider').not('.slick-initialized, .wide-product-slider').slick({
    lazyLoad: "ondemand",
    mobileFirst: true,
    autoplay: false,
    speed: 600,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: slideLeftButton,
    nextArrow: slideRightButton,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 800,
        }
      }
      ,
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          speed: 1000,
        }
      }
    ]
  });

  // Wide collection slider. Used in pages without fixed side bar
  $('.wide-product-slider').not('.slick-initialized').slick({
    lazyLoad: "ondemand",
    mobileFirst: true,
    dots: false,
    autoplay: false,
    speed: 600,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: slideLeftButton,
    nextArrow: slideRightButton,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          speed: 800,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          speed: 1000,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          speed: 1000,
        }
      }
    ]
  });
  //To include ARIA accessibility labels on sliders
  $('.slick-track').attr("aria-label","slider");

  // INIT Foundation.
  $(document).foundation();

  // INIT Woolman
  woolman.init();

  // ADD TO CART BUTTON
  $('body').on('submit', 'form[action^="/cart/add"]', function(evt) {
    // Remember which element was clicked to open the modal
    previousFocus = document.activeElement;

    evt.preventDefault();
    let skAvailability = '';    
    if(this.querySelector(".add-to-cart").dataset.skAvailability != undefined){
      skAvailability = this.querySelector(".add-to-cart").dataset.skAvailability;
    }
    woolman.addToCart($(this), skAvailability);
    //Prevent triggering from the modal form cta  
    if (document.querySelectorAll('#promoModal form')[0] != evt.currentTarget && document.getElementById("promoProduct") != null){  
      setTimeout(function(){
        PromoModal();
      }, 2000);
    }
  });

  /**
   *  Set focus on toggled elements
   */
  // Opening the cart
  $(document).on('opened.zf.offcanvas', '#offCanvasCart', function () {
    const $cartFocusable = $(this).find('a, button, input, [tabindex]:not([tabindex="-1"])').first();
    $cartFocusable.focus();
  });

  // Opening sidebar
  $(document).on('opened.zf.offcanvas', '#sidebar', function () {
    const $menuFocusable = $(this).find('a, button, input, [tabindex]:not([tabindex="-1"])')[3];
    $menuFocusable.focus();
  });

  // Closing the cart
  $(document).on('closed.zf.offcanvas', '#offCanvasCart', function() {
    previousFocus?.focus();
  });

  // Closing sidebar
  $(document).on('closed.zf.offcanvas', '#sidebar', function () {
    $menuTrigger?.focus();
  });

  // Enable escape from menu sidebar and sideCart close-button
  document.addEventListener('keyup', function (event) {

    if (event.key !== 'Escape') return;

    const sidebar = $('#sidebar');
    const hasActiveSubmenu = $('#sidebar .submenu.is-active').length > 0;
    const isSidebarOpen = sidebar.hasClass('is-open');

    const sideCart = $('#offCanvasCart');
    const isSideCartOpen = sideCart.hasClass('is-open');

    // Only close if sidebar is open and no submenu is active
    if (isSidebarOpen && !hasActiveSubmenu) {
      sidebar.foundation('close');
    }

    if (isSideCartOpen) {
      sideCart.foundation('close');
    }
  });

  // Entrap focus within element enclosed by sentinel elements
  document.addEventListener('focusin', function (e) {
    const sentinel = e.target.closest('.focus-sentinel');
    if (!sentinel) return;

    const targetSelector = sentinel.getAttribute('data-target');

    const container = document.querySelector(targetSelector);
    if (!container) return;

    const direction = sentinel.getAttribute('data-focus-redirect');

    const closeSelector = sentinel.dataset.closeButton;
    const closeButton = closeSelector ? document.querySelector(closeSelector) : null;

    let focusables = Array.from(container.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    ));

    if (closeButton && !focusables.includes(closeButton)) {
      focusables.push(closeButton);
    }

    focusables = focusables.filter(el => !el.classList.contains('focus-sentinel'));
  
    if (focusables.length === 0) return;
  
    if (direction === 'first') {
      focusables[0].focus();
    } else if (direction === 'last') {
      focusables[focusables.length - 1].focus();
    }
  });
  /**
   * Focus on toggled elements END
   */

  $('[data-cart-button]').click(function(evt) {
    evt.preventDefault();
    Shopify.analytics.publish('view_mini_cart',{
      event: 'View mini cart'
    })
    $('[data-off-canvas-cart]').foundation('open');
  });

  // ON FOCUS CLASS TO TOP PAR SEARCH
  $('#site-header-search').on('focus', function(evt) {
    $(this).closest('.site-header-search').addClass('has-focus');
  });
  $('#site-header-search').on('blur', function(evt) {
    $(this).closest('.site-header-search').removeClass('has-focus');
  });
  //Focus class top nav. New nav bar 9/2021
  $('#header-nav-search').on('focus', function(evt) {
    $(this).closest('.nav-search').addClass('has-focus');
  });
  $('#header-nav-search').on('blur', function(evt) {
    $(this).closest('.nav-search').removeClass('has-focus');
  });
  
  // PRODUCT PAGE : Handle 'type' dropdown select changes
  $('#SingleOptionSelector-0').on('change', function(evt) {
    let selectedVariant = $('#VariantSelector option:selected').index();
    $('#LoyaltyPriceLineItem input[data-index=0]').removeAttr("style").hide();
    $('#LoyaltyPriceLineItem input[data-index=1]').removeAttr("style").hide();
    $('#LoyaltyPriceLineItem input[data-index=' + selectedVariant + ']').show();
  });

  // SSKK - Cancellation Form
  var $sskkForm = $('.sskk-cancellation-form');
  var $sskkInput = $('.sskk-cancellation-form input#membership_id');
  var codeIsValid = false;

  $sskkForm.on('keyup change paste', 'input#membership_id', function() {
    if ( $(this).val().length > 9 ) {
      $(this).val( $(this).val().substr(0,9) );
    } else if ( $(this).val().length == 9 ) {
      // Perform validation
      var validateNumbers = $(this).val().replace(/\D/g,'');
      if ( validateNumbers.length < 9 ) {
        $sskkForm.find('.validate-alphabets').show();
      } else {
        $sskkForm.find('.validate-alphabets').hide();
        var numbersArray = $(this).val().split('');
        var theLastNumber = numbersArray.pop();
        var checkedNumbers = [];

        // Multiply the numbers
        for (var i = 0; i < ( numbersArray.length  ); i++) {
          var multiplier = 1;
          if (i == 1 || i == 3 || i == 5 || i == 7) {
            multiplier = 2
          }

          var newNumber = numbersArray[i] * multiplier;
          checkedNumbers.push(newNumber);
        }

        // Split the results to new array
        checkedNumbers = checkedNumbers.join('').split('');

        // Sum the results
        var summedNumber = 0;
        for (var i = 0; i < checkedNumbers.length; i++) {
          summedNumber += Number(checkedNumbers[i]);
        }

        var stringified_number = summedNumber.toString();
        if ( stringified_number.length > 1 ) {
          summedNumber = Number(summedNumber.toString().split('')[1]);
        }

        var numberToCheck = 10;
        if ( Number(theLastNumber) === 0 ) {
          numberToCheck = 0;
        }
        if ( (numberToCheck - summedNumber) == theLastNumber ) {
          codeIsValid = true;
          $sskkForm.find('.validate-numbers').hide();
          $sskkForm.find('input[type="submit"]').removeAttr('disabled');
        } else {
          codeIsValid = false;
          $sskkForm.find('.validate-numbers').show();
          $sskkForm.find('input[type="submit"]').attr('disabled', true);
        }
      }
    } else if ( $(this).val().length < 9 ) {
      $sskkForm.find('input[type="submit"]').attr('disabled', true);
    }
  });

  $sskkForm.find('input[type="submit"]').click( function(evt) {
    if ( codeIsValid ) {
      evt.preventDefault();

      if ( $(this).attr('disabled') ) { return false };

      // Format customer parameters
      var sha_digest = $('#SSKKdigest').val(),
          membershipID = $('#membership_id').val(),
          signature_timestamp = $('#SSKKtimestamp').val(),
          shop_domain = $('#SSKKshopDomain').val(),
          frends_url = "https://otava-cloudprod-agent.frendsapp.com";

      var SSKKDeleteParams = {
        "membership_id": membershipID,
        "shop": shop_domain,
        "timestamp": signature_timestamp
      };

      var $submit_btn = $sskkForm.find('input[type="submit"]');

      deleteMembershipID = function() {
        var getParams = {
          type: "DELETE",
          contentType: 'application/json',
          headers: {
            "shop_domain": shop_domain,
            "timestamp": signature_timestamp,
            "X-Authorization-Content-SHA256": sha_digest,
          },
          url: frends_url + '/api/v1/book_club/cancellation',
          data: JSON.stringify(SSKKDeleteParams),
          dataType: 'json',
          success: function(response_json) {
            $sskkForm.find('.form-success').removeClass('hidden');
            Shopify.analytics.publish('SSKK_book_cancellation',{
              event: 'SSKK kuukauden kirja peruutettu',
              sskkUserId: membershipID
            })
          },
          error: function(XMLHttpRequest, textStatus) {
            var responseStatus = XMLHttpRequest.status;
            console.dir(XMLHttpRequest);
            if ( responseStatus == 422) {
              $sskkForm.find('.form-errors[data-error="200"]').removeClass('hidden');
            } else {
              $sskkForm.find('.form-errors[data-error="400"]').removeClass('hidden');
            }
          }
        }

        $.ajax(getParams).always(function() {
          $submit_btn.removeAttr('disabled');
        });
      }();

      $submit_btn.attr('disabled', true);
    }
  });

  //Show more/show less button for elements with long text 
  var readMoreButtons = document.getElementsByClassName('read-more-button');  

  var i = 0;
  while (i < readMoreButtons.length) {    
    var buttonOpen = readMoreButtons[i].getElementsByClassName('read-more-open')[0];
    var buttonClose = readMoreButtons[i].getElementsByClassName('read-more-close')[0];
    
    readMoreButtons[i].addEventListener('click', function() {
        if(buttonOpen.style.display == 'none'){
            buttonOpen.style.setProperty('display', '');
            buttonClose.style.setProperty('display', 'none');
        }else if (buttonClose.style.display == 'none'){
            buttonOpen.style.setProperty('display', 'none');
            buttonClose.style.setProperty('display', '');
        }        
    })
    readMoreButtons[i].disabled = false; 
    i++;
  }

  // Expandable content elements. Show more/show less button  
let expandableContent = document.querySelector(".expandable-content");
if (expandableContent != null) {
  // Function to toggle the button text and expandable content
  document.querySelector(".show-more-button").addEventListener("click", function () {
    const isOpen = expandableContent.classList.toggle("open");
    const button = this;
    const showMoreText = button.getAttribute('data-show-more-string');
    const showLessText = button.getAttribute('data-show-less-string');
    button.textContent = isOpen ? showLessText : showMoreText;

    // Calculate the height of the image if present
    const image = expandableContent.querySelector("img");
    const imageHeight = image ? image.clientHeight : 0;

    // Set max-height to the full scroll height when open, else use the limited height
    if (isOpen) {
      expandableContent.style.maxHeight = `${expandableContent.scrollHeight}px`;
    } else {
      const maxHeight = window.matchMedia("(max-width: 39.9375em)").matches ? "100px" : "120px";
      expandableContent.style.maxHeight = `${parseInt(maxHeight) + imageHeight}px`;
    }
    // Set or remove the data-open attribute
    expandableContent.setAttribute("data-open", isOpen);
    // Toggle is-open class on the button
    button.classList.toggle("is-open", isOpen);
  });

  // Function to set button visibility based on content height and screen size
  function setShowMoreButtonVisibility() {
    // Temporarily remove max-height to measure full height
    expandableContent.style.maxHeight = "none";
    const expandableContentHeight = expandableContent.clientHeight;

    // Calculate the height of the image if present
    const image = expandableContent.querySelector("img");
    const imageHeight = image ? image.clientHeight : 0;

    // Set max-height back based on screen size if not open
    const maxHeight = window.matchMedia("(max-width: 39.9375em)").matches ? 100 : 120;
    if (expandableContent.getAttribute("data-open") !== "true") {
      expandableContent.style.maxHeight = `${maxHeight + imageHeight}px`;
    }
    // Show or hide the button based on content height
    const showMoreButton = document.querySelector(".show-more-button");
    if (expandableContentHeight > maxHeight + imageHeight) {
      showMoreButton.style.visibility = "visible";
      expandableContent.classList.add("gradient");
    } else {
      showMoreButton.style.visibility = "hidden";
      expandableContent.classList.remove("gradient");
    }
  }
  // Set visibility on load
  setShowMoreButtonVisibility();
  // Add event listener to update visibility on window resize
  window.addEventListener("resize", () => {
    setShowMoreButtonVisibility();
  });
}

  //Promo modal
  function PromoModal() { 
    let modalElement = document.getElementById("shopify-section-promo-modal");
    let promoProduct = parseInt(document.getElementById("promoProduct").value);
    let modalCta = document.querySelectorAll('#promoModal .add-to-cart')[0];
    let currentProductPage;
    if ( document.getElementById("currentPageProduct") != null){
      currentProductPage = parseInt(document.getElementById("currentPageProduct").value);
    }
    if ( modalElement != null && currentProductPage != promoProduct) {
      //close modal when user adds to cart
      modalCta.addEventListener("click", function(){
        $('#promoModal').foundation('close');
      });
      //check if promo product is already in cart
      checkPromoInCart(promoProduct, modalElement);    
    }
  }
  
  function refreshModal(modalElement){
    let request = new XMLHttpRequest();
    request.open('GET', '/?section_id=promo-modal', true);
    request.onload = function() {
      if (this.status == 200) {        
        modalElement.innerHTML = request.responseText;
        if(document.getElementById("promoModalInfo").value == "true"){
          let revealElement = $('#promoModal');
          new Foundation.Reveal(revealElement);
          $('#promoModal').foundation('open');
          $('[data-off-canvas-cart]').foundation('close');
        }
      }
    };
    request.send();
  }
  
  function checkPromoInCart(promoProduct, modalElement){
    let promoInCart = false
    const Http = new XMLHttpRequest();
    const url='/cart.js';
    Http.open("GET", url);    
    Http.onload = () => {
      let cartProducts = JSON.parse(Http.responseText);
      for (let i = 0; i < cartProducts.items.length; i++) {
        if(cartProducts.items[i].product_id == promoProduct){
          promoInCart = true;
        }
      }
      if(promoInCart == false) {
        //promp user to add to cart
        refreshModal(modalElement);
      }
    }
    Http.send();
  }

  // Initialize modal popups (reveal)
  function initModal(modalId, options) {
    $targetModal = $(modalId);
    if ($targetModal.length) {
      new Foundation.Reveal($targetModal , options);
    }
  }

  // Wait for Algolia search results to load before initializing modal
  woolman.waitForElm('.ais-Hits-list').then( () => {
    initModal('#filtersModal', {
      animationIn: 'slide-in-left',
      animationOut: 'slide-out-left',
      closeOnClick: true,
      hOffset: "0",
    });
  });
  // Free gift modal popups
  function FreeGiftSection() {
    let freeGiftAddModal = document.getElementById("freeGiftModal");
    let modalAddCta = document.querySelectorAll('#freeGiftModal .add-to-cart')[0];
    let freeGiftInfoModal = document.getElementById("freeGiftInfoModal");
    let infoModalCta = document.getElementById("infoModalCta");
    let freeGiftProductHandle = document.getElementById("freeGiftProductHandle");
    let qualifyingProductHandle = document.getElementById("qualifyingProductHandle");
    let nonLoyaltyModal = document.getElementById("nonLoyaltyModal");

    // addFreeGiftBundle function
    async function addFreeGiftBundle() {
      let infoModalProduct = infoModalCta.dataset.infomodalproduct;
      let infoModalFreeGift = infoModalCta.dataset.infomodalgift;

      try {
        // Fetching data for the free gift product
        const freeGiftData = await woolman.getProductExtraData(freeGiftProductHandle.value, '?view=availability.json');
        const freeGiftProductAvailability = freeGiftData['availability_text'];

        // Fetching data for the qualifying product
        const qualifyingData = await woolman.getProductExtraData(qualifyingProductHandle.value, '?view=availability.json');
        const qualifyingProductAvailability = qualifyingData['availability_text'];

        // Constructing the formData object after data retrieval
        let formData = {
          'items': [
            {
              'id': infoModalProduct,
              'quantity': 1,
              'properties': {
                '_availability_text': qualifyingProductAvailability,
              }
            },
            {
              'id': infoModalFreeGift,
              'quantity': 1,
              'properties': {
                '_free_gift_product': 'true',
                '_availability_text': freeGiftProductAvailability,
              }
            }
          ],
        };

        // Sending the formData to add items to the cart
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Failed to add items to cart');
        }

        // Update the cart and open the off-canvas cart
        woolman.getAndBuildCart();
        $('[data-off-canvas-cart]').foundation('open');
        return await response.json();

      } catch (error) {
        console.error('Error:', error);
      }
    }

    if ( freeGiftAddModal != null ) {
      //close modal when user adds to cart
      modalAddCta.addEventListener("click", function(){
        $('#freeGiftModal').foundation('close');
      }); 
    }
    if ( freeGiftInfoModal != null ) {
      $('#freeGiftInfoModal').foundation('open');

      // event listener for info modal cta
      infoModalCta.addEventListener("click", function(){
        addFreeGiftBundle();
        $('#freeGiftInfoModal').foundation('close');
      });
      
    }
    
    // Non-loyalty modal
    let scrollThreshold = 300;
    let modalOpened = false; // To track if the modal has been opened
    const modalCloseEvent = 'closed.zf.reveal'; // Foundation event when the modal is closed
  
    // Function to check if the modal can be shown based on the timestamp
    function canShowModal() {
      const lastShown = localStorage.getItem('nonLoyaltyModalLastShown');
      if (!lastShown) {
      return true; // No timestamp found, can show modal
      }
          
      const lastShownTime = parseInt(lastShown, 10);
      const currentTime = Date.now();
      const timeLimit = 5 * 60 * 1000; // 5 minutes

      if (currentTime - lastShownTime > 24 * 60 * 60 * 1000) { // Modal shown more than 24 hours ago, can show modal
        localStorage.setItem('nonLoyaltyModalShown', '0');
        return true;
      }

      const modalShown = localStorage.getItem('nonLoyaltyModalShown');
      if (modalShown && parseInt(modalShown, 10) >= 3) {
      return false; // Modal shown 3 times, do not show modal
      }
    
      return (currentTime - lastShownTime) > timeLimit;
    }
  
    // Only attach the scroll event if the modal can be shown
    if (canShowModal()) {
      $(window).on('scroll', function () {
        let scrollPosition = $(this).scrollTop();
  
        if (scrollPosition > scrollThreshold && !modalOpened) {
          modalOpened = true;
  
          if (nonLoyaltyModal != null) {
            $('#nonLoyaltyModal').foundation('open');
          }
  
          // Remove scroll event listener after opening the modal
          $(window).off('scroll');
        }
      });
    }
  
    // Event listener for when the modal is closed
    $('#nonLoyaltyModal').on(modalCloseEvent, function () {
      // Store the current time in session storage
      localStorage.setItem('nonLoyaltyModalLastShown', Date.now().toString());
      // Store in session storage how many times the modal has been shown
      let modalShown = localStorage.getItem('nonLoyaltyModalShown');
      if (!modalShown) {
        modalShown = 1;
        localStorage.setItem('nonLoyaltyModalShown', modalShown.toString());
      } else {
        modalShown = parseInt(modalShown, 10) + 1;
        localStorage.setItem('nonLoyaltyModalShown', modalShown.toString());
      }
    });
  }
  FreeGiftSection();

  // Info modal
  function handleInfoModal() {
    let modal = document.getElementById('infoModal');
    if (modal) {
      let frequency = modal.getAttribute('data-frequency');
      let whenToShow = modal.getAttribute('data-when-to-show');
      let shouldShowModal = false;
      let lastShown = localStorage.getItem('infoModalLastShown');
      let now = new Date().getTime();

      if (frequency === 'once' && !lastShown) {
        shouldShowModal = true;
      } else if (frequency === 'every_time') {
        shouldShowModal = true;
      } else if (frequency === 'after_5min' && (!lastShown || now - lastShown > 5 * 60 * 1000)) {
        shouldShowModal = true;
      } else if (frequency === 'after_10min' && (!lastShown || now - lastShown > 10 * 60 * 1000)) {
        shouldShowModal = true;
      } else if (frequency === 'after_24h' && (!lastShown || now - lastShown > 24 * 60 * 60 * 1000)) {
        shouldShowModal = true;
      } else if (frequency === 'after_48h' && (!lastShown || now - lastShown > 48 * 60 * 60 * 1000)) {
        shouldShowModal = true;
      }

      function showModal() {
        $('#infoModal').foundation('open');
        localStorage.setItem('infoModalLastShown', now);
      }

      if (shouldShowModal) {
        if (whenToShow === 'page_load') {
          setTimeout(showModal, 1000);
        } else if (whenToShow === 'after_5s') {
          setTimeout(showModal, 5000);
        } else if (whenToShow === 'scroll_down') {
          window.addEventListener('scroll', function onScroll() {
            if (window.scrollY > 250) {
              showModal();
              window.removeEventListener('scroll', onScroll);
            }
          });
        }
      }
    }
  }
  handleInfoModal();

  // Horizontal scroll buttons for multiple card lists (main page only)
  function initCardListScrollButtons() {
    if (!(window.location.pathname === '/' || window.location.pathname === '/index.html')) return;

    // Find all card lists with their left/right scroll buttons
    const cardLists = document.querySelectorAll('.card-list');
    cardLists.forEach(cardList => {
      // Find the closest parent that contains the scroll buttons and the card list
      const container = cardList.closest('.card-list-container') || cardList.parentElement;
      if (!container) return;

      const leftBtn = container.querySelector('.scroll-btn.left');
      const rightBtn = container.querySelector('.scroll-btn.right');
      const scrollAmount = 400;

      if (!leftBtn || !rightBtn) return;

      function updateScrollButtons() {
        const scrollLeft = cardList.scrollLeft;
        const maxScrollLeft = cardList.scrollWidth - cardList.clientWidth;
        const canScroll = cardList.scrollWidth > cardList.clientWidth;

        if (canScroll) {
          leftBtn.classList.remove('hide');
          rightBtn.classList.remove('hide');
          leftBtn.disabled = scrollLeft <= 0;
          rightBtn.disabled = scrollLeft >= maxScrollLeft - 1;
        } else {
          leftBtn.classList.add('hide');
          rightBtn.classList.add('hide');
        }
      }

      leftBtn.addEventListener('click', () => {
        cardList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', () => {
        cardList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      cardList.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons);
      window.addEventListener('load', updateScrollButtons);

      // Initial update
      updateScrollButtons();
    });
  }

  initCardListScrollButtons();

  // Clickable videos with data-link attribute
  // NOTE: On mobile devices, the native video controls take precedence and intercept all touch/click events,
  // so clicking the video will not trigger navigation if controls are enabled.
  // Workaround: Only make videos clickable if controls are NOT enabled.
  const clickableVideos = document.querySelectorAll('.video-with-link[data-link]');
  clickableVideos.forEach(video => {
    const link = video.getAttribute('data-link');
    if (link) {
      video.style.cursor = 'pointer';
      video.addEventListener('click', function() {
        window.location.href = link;
      });
    }
  });
});
class SideCartCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.isProcessing = false;
    this.boundClickHandler = this.handleClick.bind(this);
    this.CartAttributes = window.CartAttributes;
  }

  connectedCallback() {
    this.button = this.querySelector('button');

    if (!this.button) {
      console.error('No button found inside side-cart-checkout-button');
      return;
    }

    this.button.disabled = false;
    this.button.classList.add('ready');

    this.originalHTML = this.button.innerHTML;

    this.addEventListener('click', this.boundClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClickHandler);

    if (this.autoResetTimer) {
      clearTimeout(this.autoResetTimer);
    }
  }

  handleClick(event) {
    if (!this.button.contains(event.target)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.processCheckout();
  }

  async processCheckout() {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    this.setButtonState('loading');

    try {
      const currentAttributes = {
        ...this.CartAttributes.attributes,
        _customerAcceptsMarketing:
          this.CartAttributes.customerAcceptsMarketing() ? 'true' : 'false',
      };

      const response = await this.updateCartAttributes(currentAttributes);

      if (response && response.token) {
        window.location.href = `/checkout?token=${response.token}`;
      } else {
        window.location.href = '/checkout';
      }
    } catch (error) {
      console.error('Checkout process failed:', error);
      this.setButtonState('error');

      setTimeout(() => this.fallbackCheckout(), 2000);
    }
  }

  async updateCartAttributes(attributes, maxRetries = 3) {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000);

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ attributes }),
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
      } catch (error) {
        console.error(
          `Cart update attempt ${attempt}/${maxRetries} failed:`,
          error.message
        );

        if (attempt === maxRetries) {
          throw error;
        }

        await this.delay(Math.pow(2, attempt) * 500);
      }
    }
  }

  setButtonState(state) {
    if (!this.button) return;

    this.button.classList.remove('ready', 'loading', 'error');

    switch (state) {
      case 'loading':
        this.button.disabled = true;
        this.button.classList.add('loading');
        this.button.innerHTML = `
              <span class="loading-text">Siirrytään kassalle...</span>
              <span class="loading-spinner"></span>
            `;
        break;

      case 'error':
        this.button.disabled = false;
        this.button.classList.add('error');
        this.button.innerHTML = `<span>Yritä uudelleen</span>`;

        this.autoResetTimer = setTimeout(() => {
          if (!this.isProcessing) {
            this.setButtonState('ready');
          }
        }, 3000);
        break;

      case 'ready':
      default:
        this.button.disabled = false;
        this.button.classList.add('ready');
        this.button.innerHTML = this.originalHTML;
        this.isProcessing = false;

        if (this.autoResetTimer) {
          clearTimeout(this.autoResetTimer);
          this.autoResetTimer = null;
        }
        break;
    }
  }

  fallbackCheckout() {
    window.location.href = '/checkout';
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

customElements.define('side-cart-checkout-button', SideCartCheckoutButton);
